import {
  Component,
  ContentChildren,
  ElementRef,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import { take } from "rxjs/operators";
import * as moment from "moment";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
declare var require: any;
const htmlToPdfmake = require("html-to-pdfmake");
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import { Subject, Observable } from "rxjs";
import { WebcamImage, WebcamUtil } from "ngx-webcam";
import { MatriculaServidorHelper } from "../shared/services/matricula-servidor.helper";
import { saveAs } from "file-saver";
import * as cep from "cep-promise";
import { JwtHelper } from "../helpers/jwt-helper";
import { WhatsAppService } from "../shared/services/whatsapp.service";
import config from "../config";
import { HttpHeaders } from "@angular/common/http";
import { prepararCamposData, prepararDataParaApi } from "../helpers/date.helper";

interface StatusEnvioComprovante {
  envioId?: number;
  status?: string;
  statusDescricao?: string;
  criadoEm?: string;
  criadoEmUtc?: string;
  atualizadoEm?: string;
}

@Component({
  selector: "app-servidor-novo",
  templateUrl: "./servidor-novo.component.html",
  styleUrls: ["./servidor-novo.component.scss"],
})
export class ServidorNovoComponent implements OnInit {
  @ViewChild("comprovante")
  modalComprovante: TemplateRef<any>;

  @ViewChild("modalcomprovante", { static: true }) teste: TemplateRef<any>;

  tiposaposentadoria = [
    { name: "Aposentadoria por Idade", value: 1, group: "Para Civis" },
    {
      name: "Aposentadoria por Tempo de Contribuição",
      value: 2,
      group: "Para Civis",
    },
    {
      name: "Aposentadoria por tempo de contribuição e idade",
      value: 10,
      group: "Para Civis",
    },
    { name: "Aposentadoria Compulsória", value: 3, group: "Para Civis" },
    { name: "Aposentadoria por Invalidez", value: 4, group: "Para Civis" },
    { name: "Aposentadoria como Professor", value: 5, group: "Para Civis" },
    {
      name: "Aposentadoria Especial - atividade de risco (Art. 40, § 4o, inc. II, CF)",
      value: 6,
      group: "Para Civis",
    },
    {
      name: "Aposentadoria Especial - atividade prejudiciais à saúde ou integridade física (Art. 40, § 4o, inc. III, CF)",
      value: 7,
      group: "Para Civis",
    },
    {
      name: "Militares Inativos - Reserva Remunerada",
      value: 8,
      group: "Militares Inativos",
    },
    {
      name: "Militares Inativos - Reforma",
      value: 9,
      group: "Militares Inativos",
    },
  ];
  tipospensao = [
    { name: "Vitalícia", value: 1 },
    { name: "Temporária", value: 2 },
  ];
  sexos = [
    {
      id: "M",
      name: "Masculino",
    },
    {
      id: "F",
      name: "Feminino",
    },
  ];
  naturalizados = [
    {
      id: 1,
      name: "Sim",
    },
    {
      id: 2,
      name: "Não",
    },
  ];

  statusServidor = [
    {
      id: 1,
      name: "Ativo",
    },
    {
      id: 2,
      name: "Aposentado",
    },
    {
      id: 3,
      name: "Pensionista",
    },
    {
      id: 4,
      name: "Exonerado",
    },
    {
      id: 5,
      name: "Falecido",
    },
  ];
  statusNovaMatricula = [
    { id: 1, name: "Ativo" },
    { id: 2, name: "Aposentado" },
    { id: 3, name: "Pensionista" },
  ];
  tipoFundo = [
    "Fundo em Capitalização",
    "Fundo em Repartição",
    "Mantidos pelo Tesouro",
  ];
  tipoVinculo = ["Civil", "Militar"];
  relacaoTitularPensao = [
    {
      id: 1,
      name: "Cônjuge",
    },
    {
      id: 2,
      name: "Filho menor de 21 anos",
    },
    {
      id: 3,
      name: "Filho inválido ou com deficiência",
    },
    {
      id: 4,
      name: "Pais",
    },
    {
      id: 5,
      name: "Irmão",
    },
    {
      id: 6,
      name: "Outros",
    },
  ];

  orgaosExpedidores = [];

  referencias = [
    "Certidão de Nascimento (no caso de dependente)",
    "Certidão de Casamento (no caso de dependente)",
    "Certidão de óbito (no caso de pensionista)",
    "Termo de Posse",
    "Portaria de nomeação",
    "Concessão de aposentadoria",
    "Comprovante de Endereço",
    "Carteira de Trabalho ",
    "PIS/PASEP",
    "Carteira de Motorista (CNH)",
    "Carteira Identidade (RG)",
    "CPF",
    "Documento Dependente",
    "NIT",
    "Extrato Tempo de Serviço Passado",
    "Outros",
  ];
  anexo = {
    referencia: null,
    arquivo: null,
  };

  apiCall = this.api.new().silent();
  estados = [];
  cidades = []; // Para naturalidade do servidor
  cidadesEndereco = []; // Para endereço do servidor
  cidadesRepresentante = []; // Para representante legal
  cidadesObito = []; // Para óbito
  orgaos = [];
  estadosCivis = [];
  agenda = "";
  oldStatus;
  escolaridades = [];
  carregando = true;
  erroCarregamento = false; // true se a carga inicial falhar (mostra aviso + recarregar)
  skeletonRows = [1, 2, 3, 4, 5, 6]; // placeholders de campos no skeleton
  servidor;
  idServidor;
  idCidade;
  urlToShow = null;
  hasDadosBancarios = false;
  isPrincipalDataVisible = true;
  isAttachmentsDataVisible = false;
  isDependentsDataVisible = false;
  isMatriculaDataVisible = true;
  isTempoServicoVisible = true;
  matriculaSelecionada: any = null;
  editandoStatusMatricula = false;
  statusMatriculaEmEdicao: number = null;
  salvandoStatusMatricula = false;
  editandoDadosBeneficioMatricula = false;
  salvandoDadosBeneficioMatricula = false;
  dadosBeneficioMatricula: any = null;
  movimentosFuncionais: any[] = [];
  temposServico: any[] = [];
  estatisticasConferencia: any[] = [];
  conferenciaBlocos: { [key: string]: boolean } = {
    principal: false,
    dependentes: false,
    anexos: false,
    gerais: false,
    tsp: false,
  };
  conferenciaMatriculas: { [key: string]: boolean } = {};
  conferenciaServidorId: number = null;
  novaMatricula: any = {
    matricula: '',
    status: 1,
    cargo_atual: '',
    data_nomeacao: null,
  };
  anexos = [];
  dependentes = [];
  tiposDependencia = [];
  checkEndereco = false;
  checkContatos = false;
  copiandoEndereco = false;
  copiandoContatos = false;
  enderecoCopiado = false;
  contatosCopiados = false;
  cidadesNaturalidade = [];
  tiposLogradouro = [];
  motivosInicio = [];

  municipiosSemValidacao = [
    5009
  ]

  dependente = {
    id: null,
    id_servidor: null,
    nome: null,
    data_nascimento: null,
    estado_civil: null,
    sexo: null,
    estado_naturalidade: null,
    cidade_naturalidade: null,
    nacionalidade: null,
    naturalizado: null,
    escolaridade: null,
    nome_mae: null,
    nome_pai: null,
    deficiente: null,
    cpf: null,
    rg: null,
    data_emissao_rg: null,
    orgao_expedidor_rg: null,
    uf_rg: null,
    pis_pasep: null,
    numero_certidao: null,
    livro: null,
    folha: null,
    tipo_logradouro: null,
    logradouro: null,
    numero: null,
    complemento: null,
    bairro: null,
    estado: null,
    cidade: null,
    cep: null,
    telefone: null,
    celular: null,
    email: null,
    tipo_dependencia: null,
    motivo_inicio: null,
    motivo_fim: null,
    inicio_dependencia: null,
    fim_dependencia: null,
    fins_previdenciarios: null,
  };
  //Dados novos

  isVisible = {
    dados: false,
    documentos: false,
    dependentes: false,
  };
  //TODO
  tempoAtendimento = "04:32:55";
  statusAgendamento = "Reunião Agendada";

  isEditingBasicInfos: boolean = false;
  isEditingPersonalData: boolean = false;
  isEditingObservations: boolean = false;
  isEditingObito: boolean = false;
  isEditingRepresentante: boolean = false;
  salvandoDadosPessoais: boolean = false;
  errosDadosPessoais: { [campo: string]: string } = {};
  camposValidadosFormulario: {
    [formulario: string]: Array<{ campo: string; nome: string }>;
  } = {};

  clonedServidor = [];

  endereco = {
    cep: null,
    tipo_logradouro: null,
    logradouro: null,
    numero: null,
    id: null,
    id_servidor: null,
    complemento: null,
    bairro: null,
    estado: null,
    cidade: null,
  };
  contato = {
    id: null,
    id_servidor: null,
    telefone: null,
    celular: null,
    email: null,
  };
  documentos = {
    cpf: null,
    cpts: null,
    data_emissao_cpts: "",
    data_emissao_rg: "",
    id: null,
    id_servidor: null,
    nit: null,
    orgao_expedidor_rg: null,
    rg: null,
    secao_titulo_eleitor: null,
    serie_cpts: null,
    titulo_eleitor: null,
    uf_rg: null,
    uf_titulo_eleitor: null,
    zona_titulo_eleitor: null,
  };
  obito = {
    id: null,
    id_servidor: null,
    numero_termo: null,
    numero_folha: null,
    numero_livro: null,
    data_emissao: null,
    nome_cartorio: null,
    cnpj_cartorio: null,
    tipo_logradouro_cartorio: null,
    logradouro_cartorio: null,
    numero_cartorio: null,
    complemento_cartorio: null,
    bairro_cartorio: null,
    cep_cartorio: null,
    estado_cartorio: null,
    cidade_cartorio: null,
  };
  representante = {
    id: null,
    id_servidor: null,
    tipo_representatividade: null,
    data_inicio: null,
    data_fim: null,
    nome_representante: null,
    cpf_representante: null,
    rg_representante: null,
    orgao_expedidor_rg_representante: null,
    data_emissao_rg_representante: null,
    uf_rg_representante: null,
    data_nascimento_representante: null,
    sexo_representante: null,
    tipo_logradouro_representante: null,
    logradouro_representante: null,
    numero_representante: null,
    complemento_representante: null,
    bairro_representante: null,
    cep_representante: null,
    estado_representante: null,
    cidade_representante: null,
    telefone_representante: null,
    celular_representante: null,
    email_representante: null,
  };
  clonedDocumentos: any;
  clonedContato: any;
  clonedEndereco: any;
  clonedObito: any;
  clonedRepresentante: any;

  tiposRepresentatividade = [];

  statusOriginal: string = ""; // Guardar o valor original
  mostrarBotaoAtualizar: boolean = false; // Controla a exibição do botão

  statusAgenda = [
    { id: 1, descricao: "Reunião Não Agendada" },
    { id: 2, descricao: "Reunião Agendada" },
    { id: 3, descricao: "Reunião Realizada" },
  ];

  // Propriedades para conferidor
  isConferidor: boolean = false;
  modoSomenteLeitura: boolean = false;
  idConferidor: number = null;
  temAcessoMunicipio: boolean = false;
  situacaoConferencia: string = null; // 'conferido' ou 'cancelado'
  opcoesFinalizarConferencia = [
    { value: 'conferido', label: 'Conferido' },
  ];

  whatsappDestinatario = "";
  enviandoComprovanteWhatsApp = false;
  emailComprovanteDestinatario = "";
  enviandoComprovanteEmail = false;
  ultimoEnvioComprovante: StatusEnvioComprovante = null;
  private modalComprovanteRef: any = null;
  private readonly DDI_BRASIL = "55";

  constructor(
    private router: Router,
    private location: Location,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api,
    private whatsappService: WhatsAppService
  ) {}

  async ngOnInit() {
    const self = this;
    self.estados = [];
    self.cidades = [];
    self.orgaos = [];
    self.estadosCivis = [];
    self.escolaridades = [];
    self.servidor = null;
    self.idServidor = null;
    self.ultimoEnvioComprovante = null;
    this.mostrarBotaoAtualizar = false;
    this.isConferidor = false;
    this.modoSomenteLeitura = false;
    this.temAcessoMunicipio = false;

    // Carga inicial usa skeleton nos próprios elementos (flag `carregando`)
    // em vez do spinner fullscreen, melhorando a percepção em conexões lentas.
    self.carregando = true;
    self.erroCarregamento = false;

    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    
    // Verificar se é conferidor
    if (dadosUsuario && dadosUsuario.token) {
      self.isConferidor = JwtHelper.isConferidor(dadosUsuario.token);
      if (self.isConferidor) {
        const decodedToken = JwtHelper.decodeToken(dadosUsuario.token);
        self.idConferidor = decodedToken?.sub || null;
      }
    }
    
    // Obter parâmetros da rota usando snapshot
    const parametros = self.route.snapshot.queryParams;
    if (parametros["id"]) {
      self.idServidor = parametros["id"];
    }
    const idMatriculaSelecionada = parametros["id_matricula"]
      ? parseInt(parametros["id_matricula"], 10)
      : null;
    self.modoSomenteLeitura = self.isConferidor && parametros["modo"] === "visualizacao";
    
    // Se for conferidor, usar idCidade da query string, senão usar do usuário
    if (self.isConferidor) {
      if (parametros["idCidade"]) {
        self.idCidade = parseInt(parametros["idCidade"]);
      } else {
        // Se não tiver idCidade na query string, redirecionar
        self.spinner.hide();
        await self.app.alert('Erro!', 'ID da cidade não fornecido.', 'error');
        self.router.navigate(['/page/conferidor/municipios']);
        return;
      }
    } else {
      self.idCidade = json.user.cidade;
    }
    
    // Se for conferidor, verificar acesso ao município
    if (self.isConferidor && self.idConferidor && self.idCidade) {
      try {
        const acessoResponse = await self.apiCall
          .get(`conferidores/${self.idConferidor}/municipios/${self.idCidade}/acesso`)
          .pipe(take(1))
          .toPromise();
        
        const acessoData = acessoResponse ? JSON.parse(JSON.stringify(acessoResponse)) : null;
        self.temAcessoMunicipio = acessoData?.tem_acesso || false;
        
        if (!self.temAcessoMunicipio) {
          self.spinner.hide();
          await self.app.alert('Acesso Negado', 'Você não tem acesso a este município.', 'error');
          self.router.navigate(['/page/conferidor/municipios']);
          return;
        }
      } catch (error) {
        console.error('Erro ao verificar acesso ao município:', error);
        self.spinner.hide();
        await self.app.alert('Erro!', 'Erro ao verificar acesso ao município.', 'error');
        self.router.navigate(['/page/conferidor/municipios']);
        return;
      }
    }
    try {
    // Usar idCidade correto (do query param se for conferidor, senão do usuário)
    const cidadeParaBusca = self.isConferidor ? self.idCidade : json.user.cidade;
    const cidadeParaOrgaos = self.isConferidor ? self.idCidade : json.user.cidade;

    // Helper para disparar GETs como Promise (todas as chamadas abaixo são
    // independentes entre si, então rodam em paralelo em vez de em cascata —
    // isso reduz muito o tempo de carga em conexões lentas).
    const get = (url: string) => self.apiCall.get(url).pipe(take(1)).toPromise();

    const [
      estados,
      escolaridades,
      estadosCivis,
      servidor,
      bancario,
      orgaos,
      orgaosexpedidores,
      anexos,
      tiposDependencia,
      dependentes,
      tiposLogradouro,
      motivosInicio,
      documento,
      contato,
      endereco,
      obito,
      tiposRepresentatividade,
      representante,
      movimentosFuncionais,
      temposServico,
      estatisticasConferencia,
    ] = await Promise.all([
      get("enderecos/estados"),
      get("servidor/escolaridade"),
      get("servidor/estadocivil"),
      get(`servidor?id=${self.idServidor}&id_cidade=${cidadeParaBusca}${idMatriculaSelecionada ? `&id_matricula=${idMatriculaSelecionada}` : ''}`),
      get(`servidor/dadosbancarios?id_servidor=${self.idServidor}`),
      get("enderecos/estados/cidades/orgaos/todos?cidade=" + cidadeParaOrgaos),
      get("servidor/orgaosexpedidores"),
      get(`servidor/arquivo/todos?id_servidor=${self.idServidor}`),
      get("servidor/tiposdependencia"),
      get(`servidor/dependente/todos?id_servidor=${self.idServidor}`),
      get("enderecos/tiposLogradouro"),
      get("servidor/motivosiniciodependencia"),
      get(`servidor/documentos?id_servidor=${self.idServidor}`),
      get(`servidor/contatos?id_servidor=${self.idServidor}`),
      get(`servidor/endereco?id_servidor=${self.idServidor}`),
      get(`servidor/obito?id_servidor=${self.idServidor}`),
      get("servidor/tiposrepresentatividade"),
      get(`servidor/representantelegal?id_servidor=${self.idServidor}`),
      get(`servidor/movimentos/todos?id_servidor=${self.idServidor}`),
      get(`servidor/temposervico/todos?id_servidor=${self.idServidor}`),
      self.isConferidor && idMatriculaSelecionada
        ? get(`conferidores/estatisticas/matricula/${idMatriculaSelecionada}`)
        : Promise.resolve([]),
    ]);

    self.estados = JSON.parse(JSON.stringify(estados));
    self.escolaridades = JSON.parse(JSON.stringify(escolaridades));
    self.estadosCivis = JSON.parse(JSON.stringify(estadosCivis));
    self.servidor = MatriculaServidorHelper.normalizarServidor(
      JSON.parse(JSON.stringify(servidor)),
      cidadeParaBusca,
      idMatriculaSelecionada
    );
    self.matriculaSelecionada = MatriculaServidorHelper.getMatriculaAtiva(
      self.servidor,
      cidadeParaBusca,
      idMatriculaSelecionada
    );
    self.servidor.matricula = self.matriculaSelecionada
      ? self.matriculaSelecionada.matricula
      : MatriculaServidorHelper.getMatriculaDisplay(self.servidor);
    self.movimentosFuncionais = JSON.parse(JSON.stringify(movimentosFuncionais || []));
    self.temposServico = JSON.parse(JSON.stringify(temposServico || []));
    self.estatisticasConferencia = JSON.parse(JSON.stringify(estatisticasConferencia || []));
    self.isTempoServicoVisible = self.temMatriculaAtiva();
    if (self.isPensionistaPuro()) self.isDependentsDataVisible = false;
    if (self.isConferidor && self.estatisticasConferencia.length) {
      self.servidor.situacao_nova = self.estatisticasConferencia.every(item => item.situacao === 'conferido')
        ? 'conferido'
        : 'em_conferencia';
    }
    self.inicializarConferencia();
    self.oldStatus = servidor.status;
    if (bancario) self.hasDadosBancarios = true;
    self.orgaos = JSON.parse(JSON.stringify(orgaos));
    self.orgaosExpedidores = JSON.parse(JSON.stringify(orgaosexpedidores));

    // cidades depende do estado de naturalidade retornado em servidor
    const cidades = await get(
      "enderecos/estados/cidades?estado=" + self.servidor.estado_naturalidade
    );
    self.cidades = JSON.parse(JSON.stringify(cidades));
    this.servidor.agenda = this.statusAgenda.find(
      (item) => item.descricao === servidor.agenda
    )?.id;
   
    if (self.servidor.cidade_naturalidade)
      self.servidor.cidade_naturalidade = +self.servidor.cidade_naturalidade;
    if (
      this.servidor.valor_aposentadoria &&
      this.servidor.valor_aposentadoria.toFixed(2)
    )
      this.servidor.valor_aposentadoria = this.servidor.valor_aposentadoria
        .toFixed(2)
        .toString()
        .replace(".", ",");
    if (
      this.servidor.valor_beneficio &&
      this.servidor.valor_beneficio.toFixed(2)
    )
      this.servidor.valor_beneficio = this.servidor.valor_beneficio
        .toFixed(2)
        .toString()
        .replace(".", ",");
    if (
      this.servidor.data_nascimento &&
      moment(this.servidor.data_nascimento, "DDMMYYYY")
    )
      this.servidor.idade = moment().diff(
        moment(this.servidor.data_nascimento, "DDMMYYYY"),
        "years"
      );
    if (
      this.servidor.data_ingresso_servico_publico &&
      moment(this.servidor.data_ingresso_servico_publico)
    )
      this.servidor.data_ingresso_servico_publico = moment(
        this.servidor.data_ingresso_servico_publico
      ).format("DD/MM/YYYY");
    if (this.servidor.inicio_atendimento && this.servidor.fim_atendimento)
      this.servidor.atendimento = moment
        .utc(
          moment(this.servidor.fim_atendimento).diff(
            moment(this.servidor.inicio_atendimento)
          )
        )
        .format("HH:mm:ss");
    self.servidor.motivo_exoneracao = this.servidor.motivo_exoneracao;

    if (anexos) self.anexos = JSON.parse(JSON.stringify(anexos));

    if (tiposDependencia)
      self.tiposDependencia = JSON.parse(JSON.stringify(tiposDependencia));

    if (dependentes) {
      self.dependentes = JSON.parse(JSON.stringify(dependentes));

      for (let dependente of self.dependentes) {
        dependente.idade = moment().diff(
          moment(dependente.data_nascimento),
          "years"
        );
        dependente.labelRelacao = self.tiposDependencia.find(
          (item) => item.id === dependente.tipo_dependencia
        ) ? self.tiposDependencia.find((item) => item.id === dependente.tipo_dependencia).descricao : null;
      }
    }

    if (tiposLogradouro) {
      self.tiposLogradouro = JSON.parse(JSON.stringify(tiposLogradouro));
    }

    if (motivosInicio) {
      self.motivosInicio = JSON.parse(JSON.stringify(motivosInicio));
    }

    if (documento) self.documentos = JSON.parse(JSON.stringify(documento));

    if (contato) self.contato = JSON.parse(JSON.stringify(contato));

    if (endereco) self.endereco = JSON.parse(JSON.stringify(endereco));
    if (self.endereco.cidade) self.endereco.cidade = +self.endereco.cidade;

    if (obito) self.obito = JSON.parse(JSON.stringify(obito));
    if (self.obito.cidade_cartorio)
      self.obito.cidade_cartorio = +self.obito.cidade_cartorio;

    self.tiposRepresentatividade = JSON.parse(
      JSON.stringify(tiposRepresentatividade)
    );

    if (representante)
      self.representante = JSON.parse(JSON.stringify(representante));
    if (self.representante.cidade_representante)
      self.representante.cidade_representante =
        +self.representante.cidade_representante;

    // Carrega as cidades de endereço/óbito/representante em paralelo
    // (cada uma depende do estado já carregado acima).
    await Promise.all([
      self.endereco.estado ? self.toggleEstadoCep("servidor", false) : null,
      self.obito.estado_cartorio ? self.toggleEstadoCep("obito", false) : null,
      self.representante.estado_representante
        ? self.toggleEstadoCep("representante", false)
        : null,
    ]);

    this.statusOriginal = this.servidor.agenda;

    await self.carregarUltimoEnvioComprovante();
    await this.resetEdition()
    } catch (erro) {
      // Falha na carga inicial (ex: conexão lenta caiu). Sai do skeleton e
      // mostra o aviso de erro com o botão de recarregar.
      console.error("Erro ao carregar dados do servidor:", erro);
      self.erroCarregamento = true;
    } finally {
      self.carregando = false;
      self.spinner.hide();
      if (!self.erroCarregamento && parametros["secao"] === "matriculas") {
        setTimeout(() => self.rolarParaMatriculas(), 0);
      }
    }
  }

  // Tenta carregar os dados novamente (botão "Recarregar" do estado de erro).
  recarregar() {
    this.ngOnInit();
  }

  private rolarParaMatriculas() {
    const secao = document.getElementById('matriculas-movimentos');
    if (secao) {
      secao.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  async resetEdition() {
    this.isEditingBasicInfos = false;
    this.isEditingObito = false;
    this.isEditingRepresentante = false;
    this.isEditingPersonalData = false;
    this.isEditingObservations = false;

  }

  updateAgendaStatus(value) {
    this.mostrarBotaoAtualizar = value.id != this.statusOriginal;
    console.log("this.mostrarBotaoAtualizar", this.mostrarBotaoAtualizar);
    console.log("statusOriginal", this.statusOriginal);
    console.log("value.id", value.id);
    this.servidor.agenda = this.statusAgenda.find(
      (item) => item.descricao === value.descricao
    )?.id;
  }
  async toggleEstado() {
    this.cidades = [];
    const cidades = await this.apiCall
      .get(
        "enderecos/estados/cidades?estado=" + this.servidor.estado_naturalidade
      )
      .pipe(take(1))
      .toPromise();
    this.cidades = JSON.parse(JSON.stringify(cidades));
  }

  async toggleEstadoCep(form, showSpinner = true) {
    const self = this;

    let estadoToConsult = null;
    let targetCidadesArray = null;
    
    if (form == "servidor") {
      estadoToConsult = self.endereco.estado;
      targetCidadesArray = "cidadesEndereco";
    } else if (form == "representante") {
      estadoToConsult = self.representante.estado_representante;
      targetCidadesArray = "cidadesRepresentante";
    } else if (form == "obito") {
      estadoToConsult = self.obito.estado_cartorio;
      targetCidadesArray = "cidadesObito";
    }

    if (!estadoToConsult) {
      return;
    }

    // Na carga inicial o feedback é o skeleton da página, então não mostramos
    // o spinner fullscreen (showSpinner=false). Na interação do usuário, sim.
    if (showSpinner) {
      await self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
    }

    // Limpa o array específico do formulário
    this[targetCidadesArray] = [];

    const cidades = await this.apiCall
      .get("enderecos/estados/cidades?estado=" + estadoToConsult)
      .pipe(take(1))
      .toPromise();

    // Atualiza o array específico do formulário
    this[targetCidadesArray] = JSON.parse(JSON.stringify(cidades));
    if (showSpinner) self.spinner.hide();
  }
  async postFile(extension, type) {
    const response = await this.apiCall
      .post(`servidor/arquivo/url`, { extension: extension, type: type })
      .pipe(take(1))
      .toPromise();
    this.validarRespostaApi(
      response,
      "Não foi possível preparar o envio da imagem."
    );
    if (response.result) {
      return response.result;
    } else {
      throw new Error("O servidor não retornou uma URL para o envio da imagem.");
    }
  }

  /** Obtém o HTML do comprovante (mesmo usado pelo botão Salvar PDF / ngxPrint). */
  private getComprovanteHtml(): string {
    const el = document.getElementById("print-section");
    if (el && el.innerHTML) return el.innerHTML;
    const fallback = this.modalComprovante?.elementRef?.nativeElement;
    return fallback && fallback.innerHTML ? fallback.innerHTML : "";
  }

  /** Converte URLs de imagens no HTML para data URL (base64) para o pdfmake conseguir embutir. */
  private async htmlImagensParaDataUrl(html: string): Promise<string> {
    if (!html || typeof html !== "string") return html;
    const regex = /<img[^>]+src=["'](https?:\/\/[^"']+)["'][^>]*>/gi;
    const urls = new Set<string>();
    let m: RegExpExecArray | null;
    while ((m = regex.exec(html)) !== null) urls.add(m[1]);
    if (urls.size === 0) return html;
    const urlToDataUrl: Record<string, string> = {};
    const cacheBust = (u: string) => u + (u.includes("?") ? "&" : "?") + "x-cache=" + Date.now();
    for (const url of urls) {
      try {
        const res = await fetch(cacheBust(url), { mode: "cors", cache: "no-store" });
        if (!res.ok) continue;
        const blob = await res.blob();
        const dataUrl = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        urlToDataUrl[url] = dataUrl;
      } catch {
        // CORS ou rede: remove a img para o PDF não quebrar
        urlToDataUrl[url] = "";
      }
    }
    let out = html;
    for (const [url, dataUrl] of Object.entries(urlToDataUrl)) {
      const esc = url.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      if (dataUrl) {
        out = out.replace(new RegExp(esc, "g"), dataUrl);
      } else {
        out = out.replace(new RegExp(`<img[^>]+src=["']${esc}["'][^>]*>`, "gi"), "");
      }
    }
    return out;
  }

  /** Remove referências a fontes não disponíveis no pdfmake (Montserrat, Monospace, etc.) para usar Roboto. */
  private htmlFontesParaRoboto(html: string): string {
    if (!html || typeof html !== "string") return html;
    const fontesNaoSuportadas = ["Montserrat", "Monospace"];
    let out = html;
    for (const font of fontesNaoSuportadas) {
      const re = new RegExp(`font-family:\\s*['"]?${font}['"]?(?:\\s*,\\s*[^;]+)?`, "gi");
      out = out.replace(re, "font-family: Roboto");
      out = out.replace(new RegExp(`font:\\s*['"]?${font}['"]?(?:\\s*,\\s*[^;]+)?`, "gi"), "font: Roboto");
      out = out.replace(new RegExp(`\\b${font}\\b`, "gi"), "Roboto");
    }
    return out;
  }

  /** Garante que o conteúdo do PDF use apenas fontes disponíveis no pdfmake (ex.: Roboto). */
  private normalizarFontesPdf(content: any): any {
    if (!content) return content;
    const fontPadrao = "Roboto";
    const fontesNaoSuportadas = ["Montserrat", "montserrat", "Monospace", "monospace"];
    const usarFontPadrao = (f: string) => fontesNaoSuportadas.includes(f);
    if (Array.isArray(content)) {
      return content.map((item) => this.normalizarFontesPdf(item));
    }
    if (typeof content === "object") {
      const out = { ...content };
      if (typeof out.font === "string" && usarFontPadrao(out.font)) out.font = fontPadrao;
      if (out.style && typeof out.style === "object") {
        out.style = { ...out.style };
        if (typeof out.style.font === "string" && usarFontPadrao(out.style.font)) out.style.font = fontPadrao;
      }
      for (const key of Object.keys(out)) {
        const val = out[key];
        if (key === "text" && Array.isArray(val)) out.text = this.normalizarFontesPdf(val);
        else if (key === "content") out.content = this.normalizarFontesPdf(val);
        else if (key === "table" && val && typeof val === "object" && val.body) {
          out.table = { ...val, body: this.normalizarFontesPdf(val.body) };
        } else if (
          (key === "ul" || key === "ol" || key === "stack" || key === "columns") &&
          (Array.isArray(val) || (val && typeof val === "object"))
        ) {
          (out as any)[key] = this.normalizarFontesPdf(val);
        }
      }
      return out;
    }
    return content;
  }

  /** Converte width/height em % para números (pdfmake não aceita porcentagem). Imagens ficam 120pt para caber na 1ª página. */
  private normalizarPercentuaisPdf(content: any): any {
    if (!content) return content;
    const tamanhoFotoComprovante = 120; // pt, equivale ~150px no comprovante
    const px = (v: string | number | undefined): number | undefined => {
      if (v === undefined || v === null) return undefined;
      if (typeof v === "number" && !Number.isNaN(v)) return v;
      if (typeof v === "string") {
        const n = parseFloat(v.replace(/%/g, "").trim());
        if (!Number.isNaN(n)) return n >= 99 ? 400 : n; // 100% -> 400pt, outros % mantém valor
      }
      return undefined;
    };
    if (Array.isArray(content)) {
      return content.map((item) => this.normalizarPercentuaisPdf(item));
    }
    if (typeof content === "object") {
      const out = { ...content };
      if (typeof out.width === "string" && String(out.width).includes("%")) {
        out.width = px(out.width) ?? 400;
      }
      if (typeof out.height === "string" && String(out.height).includes("%")) {
        out.height = px(out.height) ?? 300;
      }
      if (out.style && typeof out.style === "object") {
        out.style = { ...out.style };
        if (typeof out.style.width === "string" && String(out.style.width).includes("%")) {
          out.style.width = px(out.style.width) ?? 400;
        }
        if (typeof out.style.height === "string" && String(out.style.height).includes("%")) {
          out.style.height = px(out.style.height) ?? 300;
        }
      }
      if (out.image != null) {
        out.width = tamanhoFotoComprovante;
        out.height = tamanhoFotoComprovante;
        return {
          columns: [
            { text: " ", width: "*" },
            { image: out.image, width: tamanhoFotoComprovante, height: tamanhoFotoComprovante },
          ],
        };
      }
      for (const key of Object.keys(out)) {
        const val = out[key];
        if (key === "text" && Array.isArray(val)) out.text = this.normalizarPercentuaisPdf(val);
        else if (key === "content") out.content = this.normalizarPercentuaisPdf(val);
        else if (key === "table" && val && typeof val === "object" && val.body) {
          out.table = { ...val, body: this.normalizarPercentuaisPdf(val.body) };
        } else if (
          (key === "ul" || key === "ol" || key === "stack" || key === "columns") &&
          (Array.isArray(val) || (val && typeof val === "object"))
        ) {
          (out as any)[key] = this.normalizarPercentuaisPdf(val);
        }
      }
      return out;
    }
    return content;
  }

  public downloadAsPDF() {
    const htmlSource = this.htmlFontesParaRoboto(this.getComprovanteHtml());
    let html = this.normalizarFontesPdf(htmlToPdfmake(htmlSource));
    html = this.normalizarPercentuaisPdf(html);
    const documentDefinition = { content: html, defaultStyle: { font: "Roboto" } };
    pdfMake.createPdf(documentDefinition).download();
  }

  private async getComprovantePdfBlob(): Promise<Blob> {
    const htmlSource = this.getComprovanteHtml();
    if (!htmlSource) {
      throw new Error("Conteúdo do comprovante não encontrado. Abra o relatório e tente novamente.");
    }
    const htmlComImagens = await this.htmlImagensParaDataUrl(htmlSource);
    const htmlClean = this.htmlFontesParaRoboto(htmlComImagens);
    let html = this.normalizarFontesPdf(htmlToPdfmake(htmlClean));
    html = this.normalizarPercentuaisPdf(html);
    const documentDefinition = { content: html, defaultStyle: { font: "Roboto" } };
    return new Promise((resolve, reject) => {
      pdfMake.createPdf(documentDefinition).getBlob((blob: Blob) => resolve(blob));
    });
  }

  private async uploadComprovanteToS3(blob: Blob): Promise<string> {
    const urlToPost = await this.postFile("pdf", "application/pdf");
    if (!urlToPost) throw new Error("Não foi possível obter URL para upload.");
    const options = {
      headers: { "Content-Type": "application/pdf", "x-amz-acl": "public-read" },
    };
    const urlPut = (typeof urlToPost === "string" ? urlToPost : String(urlToPost)).replace(".sa-east-1", "");
    await this.api.http.put(urlPut, blob, options).toPromise();
    return (typeof urlToPost === "string" ? urlToPost : String(urlToPost)).split("?", 1)[0];
  }

  openModalWhatsAppComprovante(content: any, modalComprovanteRef?: any) {
    this.modalComprovanteRef = modalComprovanteRef || null;
    this.whatsappDestinatario = "";
    this.enviandoComprovanteWhatsApp = false;
    this.modalService.open(content, { centered: true, size: "sm" });
  }

  openModalEmailComprovante(content: any, modalComprovanteRef?: any) {
    this.modalComprovanteRef = modalComprovanteRef || null;
    this.emailComprovanteDestinatario = "";
    this.enviandoComprovanteEmail = false;
    this.modalService.open(content, { centered: true, size: "sm" });
  }

  validarEmailComprovante(): boolean {
    const s = (this.emailComprovanteDestinatario || "").trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  }

  private isHttpApiError(res: any): boolean {
    return (
      res &&
      typeof res === "object" &&
      "status" in res &&
      typeof (res as { status?: number }).status === "number" &&
      (res as { status: number }).status >= 400
    );
  }

  private async carregarUltimoEnvioComprovante(): Promise<void> {
    const idServidor = Number(this.idServidor);
    if (!idServidor || idServidor < 1) return;

    try {
      const res = await this.apiCall
        .get(`email/servidores/${idServidor}/ultimo-envio`)
        .pipe(take(1))
        .toPromise();
      if (this.isHttpApiError(res)) return;

      const body = res as {
        success?: boolean;
        envio?: StatusEnvioComprovante;
      };
      if (body && body.success !== false) {
        this.ultimoEnvioComprovante = this.normalizarStatusEnvioComprovante(
          body.envio
        );
      }
    } catch (erro) {
      console.error("Erro ao carregar o último envio do comprovante:", erro);
    }
  }

  private normalizarStatusEnvioComprovante(
    envio: StatusEnvioComprovante
  ): StatusEnvioComprovante {
    if (!envio) return null;

    const criadoEm = String(envio.criadoEm || "").trim();
    const possuiFuso = /(Z|[+-]\d{2}:?\d{2})$/i.test(criadoEm);
    const criadoEmUtc = criadoEm
      ? possuiFuso
        ? criadoEm
        : `${criadoEm.replace(" ", "T")}Z`
      : null;

    return { ...envio, criadoEmUtc };
  }

  classeStatusComprovante(status: string): string {
    if (status === "entregue") return "comprovante-status--sucesso";
    if (["falha", "falha_entrega", "reclamacao"].indexOf(status) >= 0) {
      return "comprovante-status--erro";
    }
    return "comprovante-status--andamento";
  }

  private aguardar(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  private async acompanharStatusFinalEmail(envioId: number): Promise<void> {
    const statusFalha = ["falha", "falha_entrega", "reclamacao"];
    for (let tentativa = 0; tentativa < 24; tentativa++) {
      await this.aguardar(5000);
      const res = await this.apiCall
        .get(`email/envios/${envioId}/status`)
        .pipe(take(1))
        .toPromise();
      if (this.isHttpApiError(res)) continue;

      const body = res as {
        success?: boolean;
        status?: string;
        statusDescricao?: string;
        messageId?: string;
      };
      if (!body || body.success === false) continue;
      this.ultimoEnvioComprovante = this.normalizarStatusEnvioComprovante({
        ...(this.ultimoEnvioComprovante || {}),
        ...body,
      });
      if (body.status === "entregue") {
        await this.app.alert(
          "Entrega confirmada",
          body.statusDescricao || "O comprovante foi entregue ao servidor de e-mail do destinatário.",
          "success"
        );
        return;
      }
      if (body.status && statusFalha.indexOf(body.status) >= 0) {
        await this.app.alert(
          "Falha na entrega",
          body.statusDescricao || "Não foi possível entregar o comprovante por e-mail.",
          "error"
        );
        return;
      }
    }
  }

  async enviarComprovanteEmail(modal: any) {
    const self = this;
    const destinatario = (this.emailComprovanteDestinatario || "").trim();
    if (!this.validarEmailComprovante()) {
      await this.app.alert("Atenção", "Informe um e-mail válido.", "warning");
      return;
    }
    self.enviandoComprovanteEmail = true;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const idServidor = Number(self.idServidor);
      if (!idServidor || idServidor < 1) {
        await self.app.alert("Atenção", "Servidor não identificado. Recarregue a página e tente novamente.", "warning");
        return;
      }
      const blob = await self.getComprovantePdfBlob();
      const urlPdf = await self.uploadComprovanteToS3(blob);
      const payload = {
        id_servidor: idServidor,
        link: urlPdf,
        destinatario,
      };
      const res = await self.apiCall
        .post("email/censo-comprovante", payload)
        .pipe(take(1))
        .toPromise();
      if (self.isHttpApiError(res)) {
        const http = res as {
          status?: number;
          error?: { error?: string; statusDescricao?: string; sesRequestId?: string } | string;
          message?: string;
        };
        const respostaErro =
          http.error && typeof http.error === "object" ? http.error : null;
        const erro =
          (respostaErro && respostaErro.error) ||
          (typeof http.error === "string" ? http.error : null) ||
          http.message ||
          "Erro ao enviar e-mail.";
        const detalhesErro = [];
        if (respostaErro && respostaErro.statusDescricao) {
          detalhesErro.push(`Status: ${respostaErro.statusDescricao}.`);
        }
        detalhesErro.push(erro);
        if (respostaErro && respostaErro.sesRequestId) {
          detalhesErro.push(`ID da requisição SES: ${respostaErro.sesRequestId}`);
        }
        await self.app.alert("Erro", detalhesErro.join("\n"), "error");
        return;
      }
      const body = res as {
        success?: boolean;
        error?: string;
        status?: string;
        statusDescricao?: string;
        statusPersistido?: boolean;
        messageId?: string;
        envioId?: number;
      };
      if (body && body.success === false) {
        const detalhesErro = body.statusDescricao
          ? `Status: ${body.statusDescricao}.\n${body.error || "Erro ao enviar e-mail."}`
          : body.error || "Erro ao enviar e-mail.";
        await self.app.alert("Erro", detalhesErro, "error");
        return;
      }
      modal.close("Close click");
      await self.carregarUltimoEnvioComprovante();
      const statusDescricao =
        (body && body.statusDescricao) || "Aceito pelo Amazon SES para entrega";
      const detalhes = [`Status: ${statusDescricao}.`];
      if (body && body.messageId) detalhes.push(`ID da mensagem: ${body.messageId}`);
      if (body && body.statusPersistido === false) {
        detalhes.push("A mensagem foi aceita, mas o status não pôde ser salvo no histórico.");
      } else if (body && body.envioId) {
        detalhes.push("A confirmação final será acompanhada automaticamente por até 2 minutos.");
      }
      await self.app.alert(
        "Envio aceito",
        detalhes.join("\n"),
        body && body.statusPersistido === false ? "warning" : "success"
      );
      if (body && body.envioId && body.statusPersistido !== false) {
        self.acompanharStatusFinalEmail(body.envioId).catch((erro) => {
          console.error("Erro ao acompanhar a entrega final do e-mail:", erro);
        });
      }
    } catch (e) {
      await self.app.alert("Erro", "O envio não foi realizado. Tente novamente.", "error");
    } finally {
      self.enviandoComprovanteEmail = false;
      self.spinner.hide();
    }
  }

  validarNumeroWhatsApp(): boolean {
    const digitos = (this.whatsappDestinatario || "").replace(/\D/g, "");
    return digitos.length >= 10 && digitos.length <= 11;
  }

  /** Usado no template para habilitar o botão Enviar (evita regex no HTML). */
  podeEnviarWhatsApp(): boolean {
    const digitos = (this.whatsappDestinatario || "").replace(/\D/g, "");
    return digitos.length >= 10;
  }

  formatarNumeroWhatsApp(): string {
    const digitos = (this.whatsappDestinatario || "").replace(/\D/g, "");
    return this.DDI_BRASIL + digitos;
  }

  async enviarComprovanteWhatsApp(modal: any) {
    const self = this;
    const numero = this.formatarNumeroWhatsApp();
    if (!this.validarNumeroWhatsApp()) {
      await this.app.alert(
        "Atenção",
        "Informe um número válido (DDD + número). Ex.: 11 99999-9999",
        "warning"
      );
      return;
    }
    self.enviandoComprovanteWhatsApp = true;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const blob = await self.getComprovantePdfBlob();
      const urlPdf = await self.uploadComprovanteToS3(blob);
      const instanciasRes = await self.whatsappService
        .listarInstancias()
        .pipe(take(1))
        .toPromise() as { id: number; status: string }[] | { return?: { id: number; status: string }[]; data?: { id: number; status: string }[] } | undefined;
      const lista = Array.isArray(instanciasRes)
        ? instanciasRes
        : (instanciasRes as any)?.return ?? (instanciasRes as any)?.data ?? [];
      const allowWithoutConnected = !!(config as any).whatsapp?.allowSendWithoutConnectedInstance;
      const conectada = lista.find((i: { status: string }) => i.status === "connected");
      let idInstancia: number;
      let enviadoParaFila = false;
      if (conectada && (conectada as any).id) {
        idInstancia = (conectada as any).id;
      } else if (allowWithoutConnected && lista.length > 0 && (lista[0] as any).id) {
        idInstancia = (lista[0] as any).id;
        enviadoParaFila = true;
      } else {
        self.enviandoComprovanteWhatsApp = false;
        self.spinner.hide();
        await self.app.alert(
          "Atenção",
          "Nenhuma instância WhatsApp conectada. Conecte uma instância no painel admin.",
          "warning"
        );
        return;
      }
      const resEnvio = await self.whatsappService
        .enviarMidia(idInstancia, {
          number: numero,
          file: urlPdf,
          type: "document",
          text: "Segue o comprovante de participação do censo",
          docName: "comprovante-censo.pdf",
        })
        .pipe(take(1))
        .toPromise();
      if (resEnvio != null && typeof resEnvio === "object" && "status" in resEnvio && Number((resEnvio as { status?: number }).status) >= 400) {
        await self.app.alert("Erro", "O envio não foi realizado. Tente novamente.", "error");
        return;
      }
      const foiParaFila = enviadoParaFila || (resEnvio != null && typeof resEnvio === "object" && (resEnvio as { queued?: boolean }).queued === true);
      modal.close("Close click");
      if (foiParaFila) {
        await self.app.alert("Sucesso", "A mensagem foi colocada na fila e será enviada em até 1 dia para o número do servidor.", "success");
      } else {
        await self.app.alert("Sucesso", "Comprovante enviado por WhatsApp.", "success");
      }
    } catch (e) {
      await self.app.alert("Erro", "O envio não foi realizado. Tente novamente.", "error");
    } finally {
      self.enviandoComprovanteWhatsApp = false;
      self.spinner.hide();
    }
  }

  multipleNavigate(content) {
    this.modalService.open(content, { centered: true });
  }
  multipleWebcamsAvailable = false;
  openModalCamera(content) {
    const slef = this;
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        this.modalService.open(content, { centered: true });
      }
    );
  }
  openModal(content) {
    this.modalService.open(content, { centered: true, size: "xl" });
  }
  openModalLg(content) {
    this.anexo = { referencia: null, arquivo: null };
    this.limparValidacaoFormulario("anexo");
    const modal = this.modalService.open(content, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });
  }

  openModalSm(content) {
    const modal = this.modalService.open(content, {
      centered: true,
      size: "sm",
    });
  }

  openModalMatricula(content) {
    if (this.modoSomenteLeitura) {
      return;
    }

    this.novaMatricula = {
      matricula: '',
      status: 1,
      cargo_atual: '',
      data_nomeacao: null,
    };
    this.limparValidacaoFormulario("matricula");
    this.modalService.open(content, {
      centered: true,
      size: "lg",
      windowClass: "matricula-modal-window",
    });
  }
  fileNameAndExt(str) {
    var file = str.split("/").pop();
    return [
      file.substr(0, file.lastIndexOf(".")),
      file.substr(file.lastIndexOf(".") + 1, file.length),
    ];
  }
  viewMidia(urlToShow, content) {
    this.urlToShow = urlToShow;
    this.modalService.open(content, { centered: true });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });
    return blob;
  }

  async uploadImage(event) {
    console.log("veiooo");
    const self = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      if (file.size > 2000000) {
        await this.app.alert(
          `Atenção`,
          `o tamanho do arquivo não pode ser maior que 2mb!`,
          `error`
        );
        return;
      }
      if (file && self.fileNameAndExt(file.name)[1]) {
        try {
          self.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });
          const urlToPostFile = await self.postFile(
            self.fileNameAndExt(file.name)[1],
            file.type
          );

          if (!urlToPostFile) {
            return;
          }

          var optionsFile = {
            headers: { "Content-Type": file.type, "x-amz-acl": "public-read" },
          };

          const uploadFile = await self.api.http
            .put(urlToPostFile, file, optionsFile)
            .toPromise();

          const locationFile = urlToPostFile.toString().split("?", 1)[0];

          if (locationFile) {
            self.servidor.imagem = locationFile;
            await self.editarServidor();
          }
          console.log(locationFile);
          self.spinner.hide();
        } catch (e) {
          self.spinner.hide();
          await self.app.alert(
            "Erro",
            self.mensagemErroApi(e, "Não foi possível salvar a imagem do servidor."),
            "error"
          );
        }
      }
    };
    reader.onabort = () => {};
    reader.onerror = () => {};
  }

  private trigger: Subject<void> = new Subject<void>();
  public webcamImage: WebcamImage = null;
  public triggerSnapshot(): void {
    this.trigger.next();
  }
  async handleImage(webcamImage: WebcamImage, modal) {
    const self = this;
    let file = this.dataURItoBlob(webcamImage.imageAsBase64);
    modal.close("Close click");
    this.webcamImage = webcamImage;
    try {
      self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      const urlToPostFile = await self.postFile("jpeg", "image/jpeg");

      if (!urlToPostFile) {
        return;
      }

      var optionsFile = {
        headers: { "Content-Type": "image/jpeg", "x-amz-acl": "public-read" },
      };

      const uploadFile = await self.api.http
        .put(urlToPostFile, file, optionsFile)
        .toPromise();

      const locationFile = urlToPostFile.toString().split("?", 1)[0];

      if (locationFile) {
        self.servidor.imagem = locationFile;
        await self.editarServidor();
      }
      console.log(locationFile);
      self.spinner.hide();
    } catch (e) {
      self.spinner.hide();
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(e, "Não foi possível salvar a imagem do servidor."),
        "error"
      );
    }
  }
  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  async editarServidor(validarFormularioBasico = false) {
    const self = this;

    if (self.modoSomenteLeitura) {
      return;
    }

    if (!self.servidor || !self.servidor.id) {
      return;
    }

    if (!self.matriculaSelecionada || !self.matriculaSelecionada.id) {
      await this.app.alert(
        "Erro",
        "Selecione uma matrícula para atualizar o servidor.",
        "error"
      );
      return;
    }

    if (validarFormularioBasico && !self.validarDadosBasicos()) {
      return;
    }

    // Verificação adicional para status falecido e data de falecimento nula
    if (self.servidor.status === 5 && !self.servidor.data_falecimento) {
      await this.app.alert(
        "Erro",
        "Data de falecimento deve ser preenchida para servidores falecidos.",
        "error"
      );
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
    const dadosServidor = prepararCamposData(self.servidor, [
      "data_nascimento",
      "data_falecimento",
      "data_ingresso_servico_publico",
      "concessao_aposentadoria",
      "data_falecimento_pensao",
      "data_nascimento_pensao",
    ]);

    dadosServidor.imagem = self.servidor.imagem || "";
    dadosServidor.pendencias =
      !self.servidor.pendencias || self.servidor.pendencias == "null"
        ? ""
        : self.servidor.pendencias;
    dadosServidor.observacoes =
      !self.servidor.observacoes || self.servidor.observacoes == "null"
        ? ""
        : self.servidor.observacoes;

    dadosServidor.valor_aposentadoria = this.normalizarValorMonetario(
      dadosServidor.valor_aposentadoria
    );
    dadosServidor.valor_beneficio = this.normalizarValorMonetario(
      dadosServidor.valor_beneficio
    );

    dadosServidor.agenda = this.statusAgenda.find(
      (item) => item.id === self.servidor.agenda
    )?.descricao;

      const resposta = await this.apiCall
        .get("servidor/editar", {
          id: self.servidor.id,
          id_matricula: self.matriculaSelecionada.id,
          id_cidade: self.idCidade || self.matriculaSelecionada.id_cidade,
          matricula: self.servidor.matricula,
          nome: self.servidor.nome,
          estado_civil: self.servidor.estado_civil,
          pendencias: dadosServidor.pendencias,
          observacoes: dadosServidor.observacoes,
          motivo_exoneracao: self.servidor.motivo_exoneracao,
          status: self.servidor.status,
          data_nascimento: dadosServidor.data_nascimento,
          data_falecimento: dadosServidor.data_falecimento,
          nacionalidade: self.servidor.nacionalidade,
          estado_naturalidade: self.servidor.estado_naturalidade,
          cidade_naturalidade: self.servidor.cidade_naturalidade,
          naturalizado: self.servidor.naturalizado,
          escolaridade: self.servidor.escolaridade,
          sexo: self.servidor.sexo,
          nome_mae: self.servidor.nome_mae,
          nome_pai: self.servidor.nome_pai,
          data_ingresso_servico_publico:
            dadosServidor.data_ingresso_servico_publico,
          deficiente: self.servidor.deficiente,
          imagem: dadosServidor.imagem,
          documento_ingresso_servico_publico:
            self.servidor.documento_ingresso_servico_publico,
          paridade_aposentadoria: self.servidor.paridade_aposentadoria,
          concessao_aposentadoria: dadosServidor.concessao_aposentadoria,
          valor_aposentadoria: dadosServidor.valor_aposentadoria,
          cargo_aposentadoria: self.servidor.cargo_aposentadoria,
          pis_aposentado: self.servidor.pis_aposentado,
          tipo_aposentadoria: self.servidor.tipo_aposentadoria,
          cpf_pensao: self.servidor.cpf_pensao,
          pis_pensao: self.servidor.pis_pensao,
          nome_pensao: self.servidor.nome_pensao,
          matricula_pensao: self.servidor.matricula_pensao,
          data_nascimento_pensao: dadosServidor.data_nascimento_pensao,
          data_falecimento_pensao: dadosServidor.data_falecimento_pensao,
          tipo_pensao: self.servidor.tipo_pensao,
          valor_beneficio: dadosServidor.valor_beneficio,
          tipo_fundo: self.servidor.tipo_fundo,
          tipo_vinculo: self.servidor.tipo_vinculo,
          relacao_titular_pensao: self.servidor.relacao_titular_pensao,
          orgao: self.servidor.orgao,
          agenda: dadosServidor.agenda,
          oldStatus: self.oldStatus,
        })
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(
        resposta,
        "Não foi possível atualizar o servidor."
      );

      await this.app.alert(
        "Tudo certo!",
        "Servidor atualizado com sucesso!",
        "success"
      );
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível atualizar o servidor. Tente novamente."
        ),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }
  navigateTo(path) {
    this.router.navigate([path], {
      queryParams: {
        id: this.idServidor,
        idCidade: this.idCidade,
        id_matricula: this.matriculaSelecionada && this.matriculaSelecionada.id,
      },
    });
  }
  navigateToTempos(tipo) {
    this.router.navigate(["page/servidor/tempos"], {
      queryParams: {
        id: this.idServidor,
        idCidade: this.idCidade,
        id_matricula: this.matriculaSelecionada && this.matriculaSelecionada.id,
        tipo: tipo,
      },
    });
  }
  async iniciarAtendimento() {
    const self = this;
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const matParams = self.matriculaSelecionada && self.matriculaSelecionada.id
      ? `&id_matricula=${self.matriculaSelecionada.id}&id_cidade=${self.idCidade || self.matriculaSelecionada.id_cidade}`
      : '';
    if (!matParams) {
      await self.app.alert("Erro", "Selecione uma matrícula para iniciar o atendimento.", "error");
      self.spinner.hide();
      return;
    }
    try {
      const resposta = await this.apiCall
        .get(
          `servidor/atendimento/inicio?id_servidor=${
            self.servidor.id
          }&inicio_atendimento=${moment().format("YYYY-MM-DD HH:mm:ss")}${matParams}`
        )
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(resposta, "Não foi possível iniciar o atendimento.");
      await this.app.alert("Tudo certo!", "Atendimento iniciado!", "success");
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(erro, "Não foi possível iniciar o atendimento."),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }
  async reiniciarAtendimento() {
    const self = this;
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const matParamsRe = self.matriculaSelecionada && self.matriculaSelecionada.id
      ? `&id_matricula=${self.matriculaSelecionada.id}&id_cidade=${self.idCidade || self.matriculaSelecionada.id_cidade}`
      : '';
    if (!matParamsRe) {
      await self.app.alert("Erro", "Selecione uma matrícula para reiniciar o atendimento.", "error");
      self.spinner.hide();
      return;
    }
    try {
      const resposta = await this.apiCall
        .get(`servidor/atendimento/reinicio?id_servidor=${self.servidor.id}${matParamsRe}`)
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(resposta, "Não foi possível reiniciar o atendimento.");
      await this.app.alert("Tudo certo!", "Atendimento reiniciado!", "success");
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(erro, "Não foi possível reiniciar o atendimento."),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }
  async finalizarAtendimento() {
    const self = this;
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const matParamsFim = self.matriculaSelecionada && self.matriculaSelecionada.id
      ? `&id_matricula=${self.matriculaSelecionada.id}&id_cidade=${self.idCidade || self.matriculaSelecionada.id_cidade}`
      : '';
    if (!matParamsFim) {
      await self.app.alert("Erro", "Selecione uma matrícula para finalizar o atendimento.", "error");
      self.spinner.hide();
      return;
    }
    try {
      const resposta = await this.apiCall
        .get(
          `servidor/atendimento/fim?id_servidor=${
            self.servidor.id
          }&fim_atendimento=${moment().format("YYYY-MM-DD HH:mm:ss")}${matParamsFim}`
        )
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(resposta, "Não foi possível finalizar o atendimento.");
      await this.app.alert("Tudo certo!", "Atendimento finalizado!", "success");
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(erro, "Não foi possível finalizar o atendimento."),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }
  timer = null;

  beautifulDate(data) {
    if (!data) {
      return "";
    }
    // Tenta fazer parse sem especificar formato primeiro (para ISO strings e formatos comuns)
    let date = moment(data);
    // Se não for válido, tenta com o formato DDMMYYYY
    if (!date.isValid()) {
      date = moment(data, "DDMMYYYY");
    }
    // Se ainda não for válido, retorna string vazia
    if (!date.isValid()) {
      return "";
    }
    return date.format("DD/MM/YYYY - HH:mm:ss");
  }

  getYear(data) {
    return moment(data).format("YYYY");
  }
  preparaData(data) {
    return prepararDataParaApi(data);
  }
  getTotalDaysFromDateToToday(fromDate) {
    console.log("servidor.data_ingresso_servico_publico", fromDate);

    if (!moment(fromDate, "DD/MM/YYYY", true).isValid()) {
      console.error("Invalid date format. Expected format: DD/MM/YYYY");
      return 0;
    }

    const today = moment();
    const fromDateMoment = moment(fromDate, "DD/MM/YYYY");
    return today.diff(fromDateMoment, "days");
  }
  validateQuotes(str) {
    if (str) {
      return str.replace("'", "'");
    } else {
      return "";
    }
  }

  //Metodos novos

  goBack() {
    // Volta para a lista de servidores preservando o município selecionado,
    // para não perder a referência ao navegar de volta.
    if (this.idCidade) {
      this.router.navigate(['/page/servidores'], {
        queryParams: { idCidade: this.idCidade },
      });
    } else {
      window.history.back();
    }
  }

  toggleSection(section: string) {
    this.isVisible[section] = !this.isVisible[section];
  }

  togglePrincipalData() {
    this.isPrincipalDataVisible = !this.isPrincipalDataVisible;
  }

  toggleDependentsData() {
    this.isDependentsDataVisible = !this.isDependentsDataVisible;
  }

  toggleAttachmentsData() {
    this.isAttachmentsDataVisible = !this.isAttachmentsDataVisible;
  }

  async deleteAttachment(chave, id_arquivo) {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    const confirmou = await self.app.confirm(
      `Atenção`,
      `Você deseja mesmo deletar este anexo?`,
      `Deletar`
    );
    if (!confirmou) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const resposta = await self.apiCall
        .get("servidor/arquivo/deletar", { chave, id_arquivo })
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(resposta, "Não foi possível deletar o anexo.");
      await self.app.alert(`Sucesso`, `Anexo deletado!`, `success`);
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(erro, "Não foi possível deletar o anexo."),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }

  async downloadAttachment(chave, nome) {
    
    const self = this;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const url = await self.apiCall
      .get(`banco-dados/files/url`)
      .pipe(take(1))
      .toPromise();
    if (url) saveAs(url + chave, nome);
    self.spinner.hide();
  }

  async downloadAllExtratoTempoServico() {
    const self = this;
    
    const arquivosParaBaixar = [
      { chave: "02_undefined_48397_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_02_48397.pdf" },
      { chave: "08_undefined_48509_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_08_48509.pdf" },
      { chave: "0C_undefined_48423_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_0C_48423.pdf" },
      { chave: "0J_undefined_48223_undefined_Extrato Tempo de Serviço Passado_SERGINA - CNIS.pdf", nome: "Extrato_0J_48223.pdf" },
      { chave: "0o_undefined_48468_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_0o_48468.pdf" },
      { chave: "0p_undefined_48345_undefined_Extrato Tempo de Serviço Passado_VIVIANE CNIS.pdf", nome: "Extrato_0p_48345.pdf" },
      { chave: "0T_undefined_48330_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_0T_48330.pdf" },
      { chave: "0w_undefined_48599_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_0w_48599.pdf" },
      { chave: "14_undefined_48238_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_14_48238.pdf" },
      { chave: "1A_undefined_48358_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_1A_48358.pdf" },
      { chave: "1B_undefined_48387_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_1B_48387.pdf" },
      { chave: "1L_undefined_48200_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_1L_48200.pdf" },
      { chave: "1L_undefined_48474_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_1L_48474.pdf" },
      { chave: "1m_undefined_48225_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_1m_48225.pdf" },
      { chave: "1z_undefined_48182_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_1z_48182.pdf" },
      { chave: "2B_undefined_48367_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_2B_48367.pdf" },
      { chave: "2c_undefined_48216_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_2c_48216.jpg" },
      { chave: "2E_undefined_48347_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_2E_48347.pdf" },
      { chave: "2F_undefined_48396_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_2F_48396.pdf" },
      { chave: "2h_undefined_48521_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_2h_48521.jpg" },
      { chave: "2j_undefined_48295_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_2j_48295.pdf" },
      { chave: "2L_undefined_48581_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_2L_48581.pdf" },
      { chave: "2x_undefined_48407_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_2x_48407.pdf" },
      { chave: "31_undefined_48284_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_31_48284.pdf" },
      { chave: "33_undefined_48456_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_33_48456.pdf" },
      { chave: "3A_undefined_48400_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_3A_48400.pdf" },
      { chave: "3g_undefined_48279_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_3g_48279.pdf" },
      { chave: "3q_undefined_48284_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_3q_48284_2.pdf" },
      { chave: "3Q_undefined_48317_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_3Q_48317.pdf" },
      { chave: "42_undefined_48176_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_42_48176.pdf" },
      { chave: "45_undefined_48263_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_45_48263.pdf" },
      { chave: "45_undefined_48470_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_45_48470.pdf" },
      { chave: "47_undefined_48369_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_47_48369.pdf" },
      { chave: "4b_undefined_48272_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4b_48272.pdf" },
      { chave: "4C_undefined_48235_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4C_48235.pdf" },
      { chave: "4C_undefined_48586_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4C_48586.pdf" },
      { chave: "4H_undefined_48190_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_4H_48190.pdf" },
      { chave: "4k_undefined_48529_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_4k_48529.jpeg" },
      { chave: "4T_undefined_48222_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4T_48222.pdf" },
      { chave: "4U_undefined_48525_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4U_48525.pdf" },
      { chave: "4w_undefined_48414_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_4w_48414.pdf" },
      { chave: "5E_undefined_48404_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_5E_48404.pdf" },
      { chave: "5j_undefined_48324_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_5j_48324.pdf" },
      { chave: "6G_undefined_48444_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_6G_48444.pdf" },
      { chave: "6W_undefined_48555_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_6W_48555.pdf" },
      { chave: "71_undefined_48364_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_71_48364.pdf" },
      { chave: "71_undefined_48548_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_71_48548.pdf" },
      { chave: "7c_undefined_48482_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_7c_48482.jpeg" },
      { chave: "7o_undefined_48248_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_7o_48248.pdf" },
      { chave: "7q_undefined_48401_undefined_Extrato Tempo de Serviço Passado_CNIS (2).pdf", nome: "Extrato_7q_48401.pdf" },
      { chave: "85_undefined_48564_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_85_48564.pdf" },
      { chave: "87_undefined_48491_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_87_48491.pdf" },
      { chave: "8c_undefined_48270_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_8c_48270.pdf" },
      { chave: "8g_undefined_48506_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_8g_48506.pdf" },
      { chave: "8K_undefined_48381_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_8K_48381.pdf" },
      { chave: "8p_undefined_48458_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_8p_48458.pdf" },
      { chave: "8q_undefined_48170_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_8q_48170.pdf" },
      { chave: "8q_undefined_48201_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_8q_48201.pdf" },
      { chave: "8T_undefined_48522_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_8T_48522.pdf" },
      { chave: "9d_undefined_48496_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_9d_48496.pdf" },
      { chave: "9R_undefined_48271_undefined_Extrato Tempo de Serviço Passado_CNIS.PDF", nome: "Extrato_9R_48271.pdf" },
      { chave: "a5_undefined_48552_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_a5_48552.pdf" },
      { chave: "Aj_undefined_48327_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Aj_48327.pdf" },
      { chave: "Aj_undefined_48558_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Aj_48558.pdf" },
      { chave: "ak_undefined_48352_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ak_48352.pdf" },
      { chave: "ar_undefined_48516_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_ar_48516.pdf" },
      { chave: "As_undefined_48281_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_As_48281.jpeg" },
      { chave: "aW_undefined_48513_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_aW_48513.pdf" },
      { chave: "ax_undefined_48306_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_ax_48306.jpg" },
      { chave: "aZ_undefined_48207_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_aZ_48207.pdf" },
      { chave: "az_undefined_48550_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_az_48550.pdf" },
      { chave: "B4_undefined_48234_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_B4_48234.pdf" },
      { chave: "bB_undefined_48213_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_bB_48213.pdf" },
      { chave: "BB_undefined_48249_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_BB_48249.pdf" },
      { chave: "bJ_undefined_48334_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_bJ_48334.pdf" },
      { chave: "Bk_undefined_48260_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Bk_48260.pdf" },
      { chave: "Bo_undefined_48259_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Bo_48259.pdf" },
      { chave: "BO_undefined_48592_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_BO_48592.pdf" },
      { chave: "bS_undefined_48298_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_bS_48298.pdf" },
      { chave: "bz_undefined_48464_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_bz_48464.pdf" },
      { chave: "c4_undefined_48269_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_c4_48269.pdf" },
      { chave: "Cc_undefined_48545_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Cc_48545.pdf" },
      { chave: "Ce_undefined_48178_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ce_48178.pdf" },
      { chave: "cf_undefined_48311_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_cf_48311.pdf" },
      { chave: "Ch_undefined_48463_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ch_48463.pdf" },
      { chave: "CN_undefined_48438_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_CN_48438.jpg" },
      { chave: "CQ_undefined_48498_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_CQ_48498.pdf" },
      { chave: "Cs_undefined_48316_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Cs_48316.pdf" },
      { chave: "CU_undefined_48179_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_CU_48179.pdf" },
      { chave: "cv_undefined_48593_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_cv_48593.pdf" },
      { chave: "cZ_undefined_48338_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_cZ_48338.pdf" },
      { chave: "d5_undefined_48357_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_d5_48357.pdf" },
      { chave: "d6_undefined_48228_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_d6_48228.pdf" },
      { chave: "dF_undefined_48253_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_dF_48253.pdf" },
      { chave: "dG_undefined_48231_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_dG_48231.pdf" },
      { chave: "Di_undefined_48469_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Di_48469.pdf" },
      { chave: "Dj_undefined_48577_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Dj_48577.pdf" },
      { chave: "dL_undefined_48241_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_dL_48241.pdf" },
      { chave: "do_undefined_48236_undefined_Extrato Tempo de Serviço Passado_MARIA CANDIDA CNIS.pdf", nome: "Extrato_do_48236.pdf" },
      { chave: "do_undefined_48507_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_do_48507.pdf" },
      { chave: "DP_undefined_48601_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_DP_48601.pdf" },
      { chave: "Dq_undefined_48185_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Dq_48185.pdf" },
      { chave: "DQ_undefined_48246_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_DQ_48246.pdf" },
      { chave: "dX_undefined_48196_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_dX_48196.pdf" },
      { chave: "dY_undefined_48490_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_dY_48490.pdf" },
      { chave: "EA_undefined_48321_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_EA_48321.pdf" },
      { chave: "eA_undefined_48570_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_eA_48570.pdf" },
      { chave: "eB_undefined_48435_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_eB_48435.pdf" },
      { chave: "EC_undefined_48595_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_EC_48595.pdf" },
      { chave: "ed_undefined_48173_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ed_48173.pdf" },
      { chave: "EI_undefined_48294_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_EI_48294.pdf" },
      { chave: "eI_undefined_48527_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_eI_48527.jpg" },
      { chave: "Ek_undefined_48420_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ek_48420.pdf" },
      { chave: "EL_undefined_48184_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_EL_48184.pdf" },
      { chave: "Em_undefined_48167_undefined_Extrato Tempo de Serviço Passado_INSS CNIS.pdf", nome: "Extrato_Em_48167.pdf" },
      { chave: "EQ_undefined_48533_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_EQ_48533.pdf" },
      { chave: "Er_undefined_48346_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Er_48346.pdf" },
      { chave: "eW_undefined_48186_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_eW_48186.jpg" },
      { chave: "Ew_undefined_48433_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ew_48433.pdf" },
      { chave: "eX_undefined_48188_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_eX_48188.pdf" },
      { chave: "EX_undefined_48305_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_EX_48305.pdf" },
      { chave: "EZ_undefined_48256_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_EZ_48256.pdf" },
      { chave: "fA_undefined_48561_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_fA_48561.pdf" },
      { chave: "fE_undefined_48473_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_fE_48473.pdf" },
      { chave: "fp_undefined_48519_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_fp_48519.pdf" },
      { chave: "ft_undefined_48446_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ft_48446.pdf" },
      { chave: "FV_undefined_48275_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_FV_48275.pdf" },
      { chave: "Fw_undefined_48288_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Fw_48288.pdf" },
      { chave: "g3_undefined_48541_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_g3_48541.pdf" },
      { chave: "G4_undefined_48471_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_G4_48471.pdf" },
      { chave: "g5_undefined_48323_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_g5_48323.pdf" },
      { chave: "GH_undefined_48515_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_GH_48515.pdf" },
      { chave: "gN_undefined_48160_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_gN_48160.pdf" },
      { chave: "GR_undefined_48268_undefined_Extrato Tempo de Serviço Passado_LAIZ CNIS.pdf", nome: "Extrato_GR_48268.pdf" },
      { chave: "Gs_undefined_48314_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Gs_48314.pdf" },
      { chave: "gU_undefined_48172_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_gU_48172.pdf" },
      { chave: "gx_undefined_48383_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_gx_48383.pdf" },
      { chave: "gy_undefined_48363_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_gy_48363.pdf" },
      { chave: "GZ_undefined_48497_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_GZ_48497.pdf" },
      { chave: "H2_undefined_48394_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_H2_48394.pdf" },
      { chave: "h9_undefined_48366_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_h9_48366.pdf" },
      { chave: "hB_undefined_48299_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_hB_48299.pdf" },
      { chave: "Hh_undefined_48219_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Hh_48219.pdf" },
      { chave: "hR_undefined_48356_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_hR_48356.pdf" },
      { chave: "HY_undefined_48280_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_HY_48280.pdf" },
      { chave: "i0_undefined_48282_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_i0_48282.pdf" },
      { chave: "i4_undefined_48535_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_i4_48535.pdf" },
      { chave: "i9_undefined_48483_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_i9_48483.pdf" },
      { chave: "iB_undefined_48313_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_iB_48313.pdf" },
      { chave: "iC_undefined_48304_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_iC_48304.pdf" },
      { chave: "Ic_undefined_48326_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ic_48326.pdf" },
      { chave: "Id_undefined_48417_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_Id_48417.jpeg" },
      { chave: "IE_undefined_48325_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_IE_48325.pdf" },
      { chave: "if_undefined_48199_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_if_48199.pdf" },
      { chave: "iH_undefined_48428_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_iH_48428.pdf" },
      { chave: "II_undefined_48578_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_II_48578.pdf" },
      { chave: "ik_undefined_48197_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_ik_48197.pdf" },
      { chave: "iM_undefined_48208_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_iM_48208.pdf" },
      { chave: "iq_undefined_48373_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_iq_48373.pdf" },
      { chave: "Iy_undefined_48415_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Iy_48415.pdf" },
      { chave: "j9_undefined_48206_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_j9_48206.pdf" },
      { chave: "JD_undefined_48421_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_JD_48421.pdf" },
      { chave: "je_undefined_48301_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_je_48301.pdf" },
      { chave: "Jg_undefined_48584_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Jg_48584.pdf" },
      { chave: "jL_undefined_48310_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_jL_48310.jpg" },
      { chave: "jT_undefined_48240_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_jT_48240.pdf" },
      { chave: "Ju_undefined_48451_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Ju_48451.pdf" },
      { chave: "jx_undefined_48336_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_jx_48336.pdf" },
      { chave: "jy_undefined_48362_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_jy_48362.pdf" },
      { chave: "k9_undefined_48296_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_k9_48296.pdf" },
      { chave: "kI_undefined_48308_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_kI_48308.pdf" },
      { chave: "kK_undefined_48424_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_kK_48424.pdf" },
      { chave: "kl_undefined_48340_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_kl_48340.pdf" },
      { chave: "kl_undefined_48493_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_kl_48493.pdf" },
      { chave: "kn_undefined_48274_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_kn_48274.pdf" },
      { chave: "KR_undefined_48393_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_KR_48393.pdf" },
      { chave: "kr_undefined_48434_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_kr_48434.pdf" },
      { chave: "kw_undefined_48349_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_kw_48349.pdf" },
      { chave: "L4_undefined_48211_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_L4_48211.pdf" },
      { chave: "l8_undefined_48567_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_l8_48567.pdf" },
      { chave: "L9_undefined_48440_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_L9_48440.pdf" },
      { chave: "lB_undefined_48227_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_lB_48227.pdf" },
      { chave: "LB_undefined_48437_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_LB_48437.pdf" },
      { chave: "LO_undefined_48361_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_LO_48361.pdf" },
      { chave: "lP_undefined_48162_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_lP_48162.pdf" },
      { chave: "lR_undefined_48365_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_lR_48365.pdf" },
      { chave: "Ls_undefined_48447_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Ls_48447.pdf" },
      { chave: "lx_undefined_48226_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_lx_48226.pdf" },
      { chave: "M6_undefined_48511_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_M6_48511.pdf" },
      { chave: "M9_undefined_48312_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_M9_48312.pdf" },
      { chave: "mH_undefined_48157_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_mH_48157.pdf" },
      { chave: "Mj_undefined_48559_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Mj_48559.pdf" },
      { chave: "mN_undefined_48580_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_mN_48580.jpg" },
      { chave: "mO_undefined_48571_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_mO_48571.jpg" },
      { chave: "MQ_undefined_48419_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_MQ_48419.pdf" },
      { chave: "MT_undefined_48212_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_MT_48212.pdf" },
      { chave: "Mt_undefined_48455_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Mt_48455.pdf" },
      { chave: "mV_undefined_48543_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_mV_48543.pdf" },
      { chave: "My_undefined_48597_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_My_48597.pdf" },
      { chave: "n5_undefined_48297_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_n5_48297.jpg" },
      { chave: "n8_undefined_48198_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_n8_48198.pdf" },
      { chave: "N9_undefined_48449_undefined_Extrato Tempo de Serviço Passado_CNIS1.jpeg", nome: "Extrato_N9_48449.jpeg" },
      { chave: "NC_undefined_48165_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_NC_48165.pdf" },
      { chave: "Nc_undefined_48536_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Nc_48536.pdf" },
      { chave: "Ne_undefined_48232_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ne_48232.pdf" },
      { chave: "NK_undefined_48416_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_NK_48416.pdf" },
      { chave: "NN_undefined_48300_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_NN_48300.pdf" },
      { chave: "nU_undefined_48344_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_nU_48344.pdf" },
      { chave: "nW_undefined_48192_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_nW_48192.pdf" },
      { chave: "o6_undefined_48542_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_o6_48542.pdf" },
      { chave: "oA_undefined_48315_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_oA_48315.pdf" },
      { chave: "OC_undefined_48375_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_OC_48375.jpg" },
      { chave: "Od_undefined_48247_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Od_48247.pdf" },
      { chave: "Od_undefined_48532_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Od_48532.pdf" },
      { chave: "oM_undefined_48422_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_oM_48422.pdf" },
      { chave: "On_undefined_48215_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_On_48215.pdf" },
      { chave: "Oo_undefined_48520_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Oo_48520.pdf" },
      { chave: "Op_undefined_48267_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Op_48267.pdf" },
      { chave: "oP_undefined_48461_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_oP_48461.jpg" },
      { chave: "Os_undefined_48168_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_Os_48168.pdf" },
      { chave: "OW_undefined_48556_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_OW_48556.pdf" },
      { chave: "ox_undefined_48480_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_ox_48480.pdf" },
      { chave: "Pa_undefined_48523_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Pa_48523.pdf" },
      { chave: "pT_undefined_48503_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_pT_48503.pdf" },
      { chave: "PW_undefined_48443_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_PW_48443.pdf" },
      { chave: "pZ_undefined_48205_undefined_Extrato Tempo de Serviço Passado_extrato (1).pdf", nome: "Extrato_pZ_48205.pdf" },
      { chave: "Q4_undefined_48448_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Q4_48448.pdf" },
      { chave: "Q5_undefined_48500_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Q5_48500.pdf" },
      { chave: "Qb_undefined_48518_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Qb_48518.pdf" },
      { chave: "qM_undefined_48600_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_qM_48600.jpg" },
      { chave: "qt_undefined_48454_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_qt_48454.pdf" },
      { chave: "qU_undefined_48309_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_qU_48309.pdf" },
      { chave: "qV_undefined_48265_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_qV_48265.pdf" },
      { chave: "qz_undefined_48481_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_qz_48481.pdf" },
      { chave: "r0_undefined_48485_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_r0_48485.pdf" },
      { chave: "r4_undefined_48303_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_r4_48303.pdf" },
      { chave: "r9_undefined_48237_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_r9_48237.pdf" },
      { chave: "R9_undefined_48445_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_R9_48445.pdf" },
      { chave: "RA_undefined_48289_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_RA_48289.pdf" },
      { chave: "RB_undefined_48537_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_RB_48537.pdf" },
      { chave: "RG_undefined_48257_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_RG_48257.pdf" },
      { chave: "rm_undefined_48429_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_rm_48429.pdf" },
      { chave: "rO_undefined_48368_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_rO_48368.pdf" },
      { chave: "rO_undefined_48512_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_rO_48512.pdf" },
      { chave: "RT_undefined_48376_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_RT_48376.pdf" },
      { chave: "rW_undefined_48478_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_rW_48478.jpg" },
      { chave: "rZ_undefined_48218_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_rZ_48218.pdf" },
      { chave: "s2_undefined_48557_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_s2_48557.pdf" },
      { chave: "S7_undefined_48442_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_S7_48442.pdf" },
      { chave: "Sf_undefined_48409_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Sf_48409.pdf" },
      { chave: "sH_undefined_48524_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_sH_48524.pdf" },
      { chave: "SL_undefined_48459_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_SL_48459.pdf" },
      { chave: "So_undefined_48177_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_So_48177.pdf" },
      { chave: "ss_undefined_48341_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ss_48341.pdf" },
      { chave: "sU_undefined_48243_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_sU_48243.pdf" },
      { chave: "sX_undefined_48337_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_sX_48337.pdf" },
      { chave: "tA_undefined_48276_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_tA_48276.pdf" },
      { chave: "Ta_undefined_48539_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Ta_48539.pdf" },
      { chave: "tD_undefined_48319_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_tD_48319.pdf" },
      { chave: "Tf_undefined_48262_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_Tf_48262.jpeg" },
      { chave: "tg_undefined_48230_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_tg_48230.pdf" },
      { chave: "tJ_undefined_48390_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_tJ_48390.pdf" },
      { chave: "tN_undefined_48374_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_tN_48374.jpg" },
      { chave: "To_undefined_48164_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_To_48164.pdf" },
      { chave: "To_undefined_48439_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_To_48439.pdf" },
      { chave: "TO_undefined_48530_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_TO_48530.pdf" },
      { chave: "tq_undefined_48193_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_tq_48193.jpg" },
      { chave: "tq_undefined_48476_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_tq_48476.pdf" },
      { chave: "tr_undefined_48171_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_tr_48171.pdf" },
      { chave: "TR_undefined_48229_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_TR_48229.pdf" },
      { chave: "TV_undefined_48189_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_TV_48189.pdf" },
      { chave: "u5_undefined_48342_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_u5_48342.pdf" },
      { chave: "U6_undefined_48389_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_U6_48389.pdf" },
      { chave: "UL_undefined_48489_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_UL_48489.pdf" },
      { chave: "uQ_undefined_48180_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_uQ_48180.pdf" },
      { chave: "us_undefined_48547_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_us_48547.jpg" },
      { chave: "Uv_undefined_48487_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_Uv_48487.jpg" },
      { chave: "V4_undefined_48502_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_V4_48502.pdf" },
      { chave: "V8_undefined_48163_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_V8_48163.pdf" },
      { chave: "Vd_undefined_48465_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Vd_48465.pdf" },
      { chave: "VE_undefined_48242_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_VE_48242.pdf" },
      { chave: "vE_undefined_48572_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_vE_48572.pdf" },
      { chave: "vG_undefined_48466_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_vG_48466.pdf" },
      { chave: "VI_undefined_48291_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_VI_48291.pdf" },
      { chave: "VI_undefined_48462_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_VI_48462.pdf" },
      { chave: "vt_undefined_48551_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_vt_48551.pdf" },
      { chave: "W0_undefined_48430_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_W0_48430.pdf" },
      { chave: "W2_undefined_48252_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_W2_48252.pdf" },
      { chave: "W3_undefined_48425_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_W3_48425.pdf" },
      { chave: "w8_undefined_48258_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_w8_48258.pdf" },
      { chave: "WD_undefined_48233_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_WD_48233.jpg" },
      { chave: "Wd_undefined_48370_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Wd_48370.pdf" },
      { chave: "Wh_undefined_48195_undefined_Extrato Tempo de Serviço Passado_ODINEUSA CNIS.jpeg", nome: "Extrato_Wh_48195.jpeg" },
      { chave: "WM_undefined_48484_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_WM_48484.pdf" },
      { chave: "Ws_undefined_48261_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Ws_48261.pdf" },
      { chave: "wx_undefined_48217_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_wx_48217.pdf" },
      { chave: "Wx_undefined_48411_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Wx_48411.pdf" },
      { chave: "WZ_undefined_48494_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_WZ_48494.pdf" },
      { chave: "xA_undefined_48343_undefined_Extrato Tempo de Serviço Passado_CNIS2.jpeg", nome: "Extrato_xA_48343.jpeg" },
      { chave: "XB_undefined_48333_undefined_Extrato Tempo de Serviço Passado_WhatsApp Image 2025-09-29 at 21.04.14.jpeg", nome: "Extrato_XB_48333.jpeg" },
      { chave: "xh_undefined_48510_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_xh_48510.pdf" },
      { chave: "xN_undefined_48169_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_xN_48169.pdf" },
      { chave: "xu_undefined_48187_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_xu_48187.pdf" },
      { chave: "xu_undefined_48329_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_xu_48329.pdf" },
      { chave: "Xx_undefined_48398_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Xx_48398.pdf" },
      { chave: "y0_undefined_48526_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_y0_48526.jpg" },
      { chave: "Yc_undefined_48594_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_Yc_48594.pdf" },
      { chave: "YE_undefined_48166_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_YE_48166.pdf" },
      { chave: "yK_undefined_48403_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_yK_48403.pdf" },
      { chave: "Yl_undefined_48264_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Yl_48264.pdf" },
      { chave: "ym_undefined_48406_undefined_Extrato Tempo de Serviço Passado_File.jpg", nome: "Extrato_ym_48406.jpg" },
      { chave: "YO_undefined_48266_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_YO_48266.pdf" },
      { chave: "YO_undefined_48453_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_YO_48453.pdf" },
      { chave: "yP_undefined_48221_undefined_Extrato Tempo de Serviço Passado_MARCELO CNIS.pdf", nome: "Extrato_yP_48221.pdf" },
      { chave: "YP_undefined_48245_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_YP_48245.pdf" },
      { chave: "yP_undefined_48290_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_yP_48290.pdf" },
      { chave: "Yq_undefined_48183_undefined_Extrato Tempo de Serviço Passado_extrato.pdf", nome: "Extrato_Yq_48183.pdf" },
      { chave: "Yq_undefined_48427_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_Yq_48427.pdf" },
      { chave: "YQ_undefined_48563_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_YQ_48563.pdf" },
      { chave: "ys_undefined_48250_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ys_48250.pdf" },
      { chave: "yV_undefined_48405_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_yV_48405.jpeg" },
      { chave: "yY_undefined_48181_undefined_Extrato Tempo de Serviço Passado_CNIS.pdf", nome: "Extrato_yY_48181.pdf" },
      { chave: "yY_undefined_48475_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_yY_48475.pdf" },
      { chave: "ZH_undefined_48528_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ZH_48528.pdf" },
      { chave: "zH_undefined_48553_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_zH_48553.pdf" },
      { chave: "zI_undefined_48255_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_zI_48255.pdf" },
      { chave: "ZK_undefined_48384_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_ZK_48384.pdf" },
      { chave: "ZR_undefined_48479_undefined_Extrato Tempo de Serviço Passado_CNIS.jpeg", nome: "Extrato_ZR_48479.jpeg" },
      { chave: "zs_undefined_48293_undefined_Extrato Tempo de Serviço Passado_File.pdf", nome: "Extrato_zs_48293.pdf" }
    ];

    if (!await self.app.confirm(
      `Download em Massa`,
      `Deseja baixar ${arquivosParaBaixar.length} arquivos de Extrato de Tempo de Serviço?`,
      `Baixar Todos`
    )) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const url = await self.apiCall
        .get(`banco-dados/files/url`)
        .pipe(take(1))
        .toPromise();

      if (url) {
        let contador = 0;
        for (const arquivo of arquivosParaBaixar) {
          try {
            // Adiciona um pequeno delay entre downloads para evitar sobrecarga
            if (contador > 0) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }
            saveAs(url + arquivo.chave, arquivo.nome);
            contador++;
          } catch (error) {
            console.error(`Erro ao baixar ${arquivo.nome}:`, error);
          }
        }
        
        await self.app.alert(
          `Sucesso`,
          `${contador} arquivos iniciados para download!`,
          `success`
        );
      }
    } catch (error) {
      console.error('Erro no download em massa:', error);
      await self.app.alert(
        `Erro`,
        `Ocorreu um erro ao baixar os arquivos.`,
        `error`
      );
    } finally {
      self.spinner.hide();
    }
  }

  beautifulDateSimple(data) {
    if (!data) {
      return "";
    }
    // Tenta fazer parse sem especificar formato primeiro (para ISO strings e formatos comuns)
    let date = moment(data);
    // Se não for válido, tenta com o formato DDMMYYYY
    if (!date.isValid()) {
      date = moment(data, "DDMMYYYY");
    }
    // Se ainda não for válido, retorna string vazia
    if (!date.isValid()) {
      return "";
    }
    return date.format("DD/MM/YYYY");
  }

  async selecionaArquivo(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file);
      if (file.size > 5000000) {
        event.target.value = null;
        await this.app.alert(
          `Atenção`,
          `o tamanho do arquivo não pode ser maior que 5mb!`,
          `error`
        );
      } else {
        this.anexo.arquivo = file;
      }
    }
  }

  async cadastrarAnexo(modal) {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    if (!self.validarAnexo()) {
      return;
    }

    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const arquivo: File = self.anexo.arquivo;
      const partesNome = arquivo.name.split(".");
      const extensao = partesNome.length > 1 ? partesNome.pop() : "bin";
      const tipo = arquivo.type || "application/octet-stream";

      const assinatura = await self.apiCall
        .post("servidor/arquivo/url", { extension: extensao, type: tipo })
        .pipe(take(1))
        .toPromise();

      if (!assinatura || !assinatura.result || !assinatura.key) {
        throw new Error("Não foi possível preparar o envio do arquivo.");
      }

      await self.api.http
        .put(assinatura.result, arquivo, {
          headers: new HttpHeaders({
            "Content-Type": tipo,
            "x-amz-acl": "public-read",
          }),
          responseType: "text",
        })
        .toPromise();

      const confirmacao = await self.apiCall
        .post("servidor/arquivo/confirmar", {
          id_servidor: Number(self.idServidor),
          nome: arquivo.name,
          tipo: tipo,
          referencia: self.anexo.referencia,
          chave: assinatura.key,
        })
        .pipe(take(1))
        .toPromise();

      if (!confirmacao || confirmacao.success !== true) {
        throw new Error(
          (confirmacao && confirmacao.error && confirmacao.error.message) ||
            (confirmacao && confirmacao.error) ||
            "Não foi possível registrar o anexo."
        );
      }

      await self.app.alert(`Sucesso`, `Anexo cadastrado!`, `success`);
      modal.close("Close click");
      await self.ngOnInit();
    } catch (error) {
      console.error("Erro ao cadastrar anexo:", error);
      await self.app.alert(
        `Erro`,
        (error && error.message) || `Não foi possível cadastrar o anexo.`,
        `error`

      );
    } finally {
      await self.spinner.hide();
    }
  }
  async deletarDependente(id) {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    const confirmou = await self.app.confirm(
      `Atenção`,
      `Você deseja mesmo deletar este dependente?`,
      `Deletar`
    );
    if (!confirmou) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const deleteDependente = await self.apiCall
        .get(
          `servidor/dependente/deletar?id_dependente=${id}&id_servidor=${self.idServidor}`
        )
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(
        deleteDependente,
        "Não foi possível deletar o dependente."
      );
      await self.app.alert(`Sucesso`, `Dependente deletado!`, `success`);
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(erro, "Não foi possível deletar o dependente."),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }

  resetaDependente() {
    this.dependente = {
      id: null,
      id_servidor: null,
      nome: null,
      data_nascimento: null,
      estado_civil: null,
      sexo: null,
      estado_naturalidade: null,
      cidade_naturalidade: null,
      nacionalidade: null,
      naturalizado: null,
      escolaridade: null,
      nome_mae: null,
      nome_pai: null,
      deficiente: null,
      cpf: null,
      rg: null,
      data_emissao_rg: null,
      orgao_expedidor_rg: null,
      uf_rg: null,
      pis_pasep: null,
      numero_certidao: null,
      livro: null,
      folha: null,
      tipo_logradouro: null,
      logradouro: null,
      numero: null,
      complemento: null,
      bairro: null,
      estado: null,
      cidade: null,
      cep: null,
      telefone: null,
      celular: null,
      email: null,
      tipo_dependencia: null,
      motivo_inicio: null,
      motivo_fim: null,
      inicio_dependencia: null,
      fim_dependencia: null,
      fins_previdenciarios: null,
    };
  }

  async openModalDependent(content, dependente) {
    if (this.modoSomenteLeitura && !dependente) {
      return;
    }

    if (dependente) {
      this.dependente = { ...dependente };
      if (dependente.data_emissao_rg)
        this.dependente.data_emissao_rg = moment
          .utc(dependente.data_emissao_rg)
          .format("DDMMYYYY");
      if (dependente.data_nascimento)
        this.dependente.data_nascimento = moment
          .utc(dependente.data_nascimento)
          .format("DDMMYYYY");
      if (dependente.estado_naturalidade) {
        const cidades = await this.apiCall
          .get(
            "enderecos/estados/cidades?estado=" + dependente.estado_naturalidade
          )
          .pipe(take(1))
          .toPromise();
        this.cidadesNaturalidade = JSON.parse(JSON.stringify(cidades));
        if (dependente.cidade_naturalidade)
          this.dependente.cidade_naturalidade = +dependente.cidade_naturalidade;
      }
      if (dependente.estado) {
        const cidades = await this.apiCall
          .get("enderecos/estados/cidades?estado=" + dependente.estado)
          .pipe(take(1))
          .toPromise();
        this.cidades = JSON.parse(JSON.stringify(cidades));
        if (dependente.cidade) this.dependente.cidade = +dependente.cidade;
      }
    } else {
      this.resetaDependente();
      this.cidadesNaturalidade = [];
      this.cidades = [];
    }
    this.checkContatos = false;
    this.checkEndereco = false;
    this.copiandoContatos = false;
    this.copiandoEndereco = false;
    this.contatosCopiados = false;
    this.enderecoCopiado = false;
    this.limparValidacaoFormulario("dependente");
    const modal = this.modalService.open(content, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });
  }

  async toggleEstadoDependente(naturalidade) {
    const self = this;
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    if (naturalidade && !this.dependente.estado_naturalidade) {
      return;
    }
    if (!naturalidade && !this.dependente.estado) {
      return;
    }

    if (naturalidade) {
      this.cidadesNaturalidade = [];
      this.dependente.cidade_naturalidade = null;
      const cidades = await this.apiCall
        .get(
          "enderecos/estados/cidades?estado=" +
            this.dependente.estado_naturalidade
        )
        .pipe(take(1))
        .toPromise();
      this.cidadesNaturalidade = JSON.parse(JSON.stringify(cidades));
    } else {
      this.cidades = [];
      this.dependente.cidade = null;
      const cidades = await this.apiCall
        .get("enderecos/estados/cidades?estado=" + this.dependente.estado)
        .pipe(take(1))
        .toPromise();
      this.cidades = JSON.parse(JSON.stringify(cidades));
      console.log("this.cidades", this.cidades);
    }
    await self.spinner.hide();
  }
  async copiaContatos($event) {
    const self = this;
    this.checkContatos = !!($event && $event.target && $event.target.checked);
    this.contatosCopiados = false;
    if (!this.checkContatos) return;

    this.copiandoContatos = true;
    try {
      const contato = await self.apiCall
        .get("servidor/contatos?id_servidor=" + self.idServidor)
        .pipe(take(1))
        .toPromise();

      if (!contato || typeof contato === "string" ||
          ![contato.telefone, contato.celular, contato.email].some(valor => this.temValor(valor))) {
        this.checkContatos = false;
        await this.app.alert(
          "Atenção!",
          "O titular não possui telefone, celular ou e-mail cadastrado para copiar.",
          "warning"
        );
        return;
      }

      self.dependente.telefone = contato.telefone || null;
      self.dependente.celular = contato.celular || null;
      self.dependente.email = contato.email || null;
      this.contatosCopiados = true;
    } catch (error) {
      this.checkContatos = false;
      await this.app.alert(
        "Erro!",
        "Não foi possível copiar os contatos do titular. Tente novamente.",
        "error"
      );
    } finally {
      this.copiandoContatos = false;
    }
  }

  async copiaEndereco($event) {
    const self = this;
    this.checkEndereco = !!($event && $event.target && $event.target.checked);
    this.enderecoCopiado = false;
    if (!this.checkEndereco) return;

    this.copiandoEndereco = true;
    try {
      const endereco = await self.apiCall
        .get("servidor/endereco?id_servidor=" + self.idServidor)
        .pipe(take(1))
        .toPromise();

      const camposObrigatorios = [
        endereco && endereco.cep,
        endereco && endereco.tipo_logradouro,
        endereco && endereco.logradouro,
        endereco && endereco.numero,
        endereco && endereco.bairro,
        endereco && endereco.estado,
        endereco && endereco.cidade,
      ];
      if (!endereco || typeof endereco === "string" || camposObrigatorios.some(valor => !this.temValor(valor))) {
        this.checkEndereco = false;
        await this.app.alert(
          "Atenção!",
          "O endereço do titular está incompleto. Revise CEP, logradouro, número, bairro, estado e cidade antes de copiar.",
          "warning"
        );
        return;
      }

      const cidades = await self.apiCall
        .get("enderecos/estados/cidades?estado=" + endereco.estado)
        .pipe(take(1))
        .toPromise();
      self.cidades = cidades ? JSON.parse(JSON.stringify(cidades)) : [];
      self.dependente.tipo_logradouro = endereco.tipo_logradouro;
      self.dependente.logradouro = endereco.logradouro;
      self.dependente.numero = endereco.numero;
      self.dependente.complemento = endereco.complemento || null;
      self.dependente.bairro = endereco.bairro;
      self.dependente.estado = endereco.estado;
      self.dependente.cidade = +endereco.cidade;
      self.dependente.cep = endereco.cep;
      this.enderecoCopiado = true;
    } catch (error) {
      this.checkEndereco = false;
      await this.app.alert(
        "Erro!",
        "Não foi possível copiar o endereço do titular. Tente novamente.",
        "error"
      );
    } finally {
      this.copiandoEndereco = false;
    }
  }

  private temValor(valor: any): boolean {
    return valor !== null && valor !== undefined && String(valor).trim() !== "";
  }
  consultaCep(form = null) {
    const self = this;
    console.log(form);
    if (
      !self.dependente.cep &&
      !self.obito.cep_cartorio &&
      !self.representante.cep_representante &&
      !self.endereco.cep
    ) {
      return;
    }
    let cepToConsult = null;
    let targetObject = null;
    let logradouroField = "logradouro";
    let bairroField = "bairro";
    let estadoField = "estado";
    let cidadeField = "cidade";
    let tipoLogradouroField = "tipo_logradouro";
    let targetCidadesArray = null;

    if (form == "servidor") {
      cepToConsult = self.endereco.cep;
      targetObject = self.endereco;
      targetCidadesArray = "cidadesEndereco";
    } else if (form == "dependente") {
      cepToConsult = self.dependente.cep;
      targetObject = self.dependente;
      targetCidadesArray = "cidades";
    } else if (form == "representante") {
      cepToConsult = self.representante.cep_representante;
      targetObject = self.representante;
      logradouroField = "logradouro_representante";
      bairroField = "bairro_representante";
      estadoField = "estado_representante";
      cidadeField = "cidade_representante";
      tipoLogradouroField = "tipo_logradouro_representante";
      targetCidadesArray = "cidadesRepresentante";
    } else if (form == "obito") {
      cepToConsult = self.obito.cep_cartorio;
      targetObject = self.obito;
      logradouroField = "logradouro_cartorio";
      bairroField = "bairro_cartorio";
      estadoField = "estado_cartorio";
      cidadeField = "cidade_cartorio";
      tipoLogradouroField = "tipo_logradouro_cartorio";
      targetCidadesArray = "cidadesObito";
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    cep(cepToConsult)
      .then(async (local) => {
        targetObject[logradouroField] = local.street;
        targetObject[bairroField] = local.neighborhood;
        targetObject[estadoField] = local.state;
        targetObject[cidadeField] = null;
        targetObject[tipoLogradouroField] = null;

        if (form == "dependente") {
          await self.toggleEstadoDependente(false);
        } else {
          await self.toggleEstadoCep(form);
        }

        // Usa o array de cidades correto baseado no formulário
        const cidadesArray = self[targetCidadesArray];
        const foundCity = cidadesArray.find((c) =>
          c.nome.toLowerCase().includes(local.city.toLowerCase())
        );
        if (foundCity) targetObject[cidadeField] = foundCity.id;

        const foundTipoLogradouro = self.tiposLogradouro.find((t) =>
          t.descricao
            .toLowerCase()
            .includes(local.street.split(" ")[0].toLowerCase())
        );
        if (foundTipoLogradouro)
          targetObject[tipoLogradouroField] = foundTipoLogradouro.id;

        self.spinner.hide();
      })
      .catch((erro) => {
        console.error("Erro ao buscar o CEP:", erro);
        self.spinner.hide();
      });
  }

  toggleEditBasicInfos(revert = false) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (revert == false) {
      this.clonedServidor = JSON.parse(JSON.stringify(this.servidor));
    }

    if (revert == true) {
      this.servidor = JSON.parse(JSON.stringify(this.clonedServidor));
    }
    this.limparValidacaoFormulario("basico");
    this.isEditingBasicInfos = !this.isEditingBasicInfos;
  }

  toggleEditObservations(revert = false) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (revert == false) {
      this.clonedServidor = JSON.parse(JSON.stringify(this.servidor));
    }

    if (revert == true) {
      this.servidor = JSON.parse(JSON.stringify(this.clonedServidor));
    }
    this.limparValidacaoFormulario("pendencias");
    this.isEditingObservations = !this.isEditingObservations;
  }

  toggleEditPersonalData(revert = false) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (revert == false) {
      this.clonedDocumentos = JSON.parse(JSON.stringify(this.documentos));
      this.clonedContato = JSON.parse(JSON.stringify(this.contato));
      this.clonedEndereco = JSON.parse(JSON.stringify(this.endereco));
    }

    if (revert == true) {
      this.documentos = JSON.parse(JSON.stringify(this.clonedDocumentos));
      this.contato = JSON.parse(JSON.stringify(this.clonedContato));
      this.endereco = JSON.parse(JSON.stringify(this.clonedEndereco));
    }
    this.errosDadosPessoais = {};
    this.isEditingPersonalData = !this.isEditingPersonalData;
  }

  toggleEditObito(revert = false) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (revert == false) {
      this.clonedObito = JSON.parse(JSON.stringify(this.obito));
    }

    if (revert == true) {
      this.obito = JSON.parse(JSON.stringify(this.clonedObito));
    }

    this.limparValidacaoFormulario("obito");
    this.isEditingObito = !this.isEditingObito;
  }

  toggleEditRepresentante(revert = false) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (revert == false) {
      this.clonedRepresentante = JSON.parse(JSON.stringify(this.representante));
    }

    if (revert == true) {
      this.representante = JSON.parse(JSON.stringify(this.clonedRepresentante));
    }

    this.limparValidacaoFormulario("representante");
    this.isEditingRepresentante = !this.isEditingRepresentante;
  }

  private valorVazio(valor: any): boolean {
    return valor === null || valor === undefined ||
      (typeof valor === "string" && valor.trim() === "");
  }

  private valorCampoFormulario(formulario: string, campo: string): any {
    if (formulario === "mini") {
      return campo === "cpf"
        ? this.documentos && this.documentos.cpf
        : this.servidor && this.servidor[campo];
    }
    const origens = {
      basico: this.servidor,
      obito: this.obito,
      representante: this.representante,
      dependente: this.dependente,
      anexo: this.anexo,
      matricula: this.novaMatricula,
      "beneficio-matricula": this.dadosBeneficioMatricula,
      pendencias: this.servidor,
    };
    const origem = origens[formulario];
    return origem ? origem[campo] : null;
  }

  private validarCamposObrigatorios(
    formulario: string,
    campos: Array<{ campo: string; nome: string }>
  ): boolean {
    this.camposValidadosFormulario[formulario] = campos;
    const erros = this.getErrosFormulario(formulario);

    if (erros.length) {
      setTimeout(() => {
        const primeiroCampo = document.querySelector(
          `.formulario-${formulario} .is-invalid`
        ) as HTMLElement;
        if (primeiroCampo) {
          primeiroCampo.focus();
          primeiroCampo.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 0);
    }

    return erros.length === 0;
  }

  getErrosFormulario(formulario: string): Array<{ campo: string; nome: string }> {
    return (this.camposValidadosFormulario[formulario] || []).filter(item =>
      this.valorVazio(this.valorCampoFormulario(formulario, item.campo))
    );
  }

  possuiErrosFormulario(formulario: string): boolean {
    return this.getErrosFormulario(formulario).length > 0;
  }

  mensagemErrosFormulario(formulario: string): string {
    return this.getErrosFormulario(formulario).map(item => item.nome).join(", ");
  }

  erroCampoFormulario(formulario: string, campo: string): string {
    const item = (this.camposValidadosFormulario[formulario] || [])
      .find(campoValidado => campoValidado.campo === campo);
    if (!item || !this.valorVazio(this.valorCampoFormulario(formulario, campo))) {
      return null;
    }
    return `O campo ${item.nome} é obrigatório.`;
  }

  limparValidacaoFormulario(formulario: string): void {
    delete this.camposValidadosFormulario[formulario];
  }

  validarDadosBasicos(): boolean {
    if (this.checkMunicipio()) {
      this.limparValidacaoFormulario("basico");
      return true;
    }

    const campos = [
      { campo: "nome", nome: "Nome" },
      { campo: "sexo", nome: "Sexo" },
      { campo: "data_nascimento", nome: "Nascimento" },
      { campo: "estado_civil", nome: "Estado Civil" },
      { campo: "nome_mae", nome: "Nome Mãe" },
      { campo: "nome_pai", nome: "Nome Pai" },
      { campo: "nacionalidade", nome: "Nacionalidade" },
      { campo: "naturalizado", nome: "Naturalizado" },
      { campo: "estado_naturalidade", nome: "UF de Naturalidade" },
      { campo: "cidade_naturalidade", nome: "Cidade de Naturalidade" },
      { campo: "escolaridade", nome: "Escolaridade" },
      { campo: "deficiente", nome: "Pessoa com deficiência - PCD" },
    ];

    if (this.servidor && +this.servidor.status === 3) {
      campos.push({ campo: "tipo_vinculo", nome: "Tipo de Vínculo" });
    }
    if (this.servidor && +this.servidor.status === 5) {
      campos.push({ campo: "data_falecimento", nome: "Data de Falecimento" });
    }

    return this.validarCamposObrigatorios("basico", campos);
  }

  validarObito(): boolean {
    return this.validarCamposObrigatorios("obito", [
      { campo: "nome_cartorio", nome: "Nome Cartório" },
      { campo: "cep_cartorio", nome: "CEP" },
      { campo: "tipo_logradouro_cartorio", nome: "Tipo Logradouro" },
      { campo: "logradouro_cartorio", nome: "Logradouro" },
      { campo: "numero_cartorio", nome: "Número" },
      { campo: "estado_cartorio", nome: "Estado" },
      { campo: "cidade_cartorio", nome: "Cidade" },
      { campo: "bairro_cartorio", nome: "Bairro" },
      { campo: "complemento_cartorio", nome: "Complemento" },
      { campo: "data_emissao", nome: "Data de Emissão" },
      { campo: "numero_termo", nome: "Número Termo" },
      { campo: "numero_livro", nome: "Número Livro" },
      { campo: "numero_folha", nome: "Número Folha" },
    ]);
  }

  validarRepresentante(): boolean {
    return this.validarCamposObrigatorios("representante", [
      { campo: "tipo_representatividade", nome: "Tipo Representatividade" },
      { campo: "data_inicio", nome: "Início da Representação" },
      { campo: "data_fim", nome: "Fim da Representação" },
      { campo: "nome_representante", nome: "Nome" },
      { campo: "sexo_representante", nome: "Sexo" },
      { campo: "data_nascimento_representante", nome: "Nascimento" },
      { campo: "cpf_representante", nome: "CPF" },
      { campo: "rg_representante", nome: "RG" },
      { campo: "data_emissao_rg_representante", nome: "Emissão RG" },
      { campo: "orgao_expedidor_rg_representante", nome: "Órgão Expedidor RG" },
      { campo: "uf_rg_representante", nome: "UF do RG" },
      { campo: "cep_representante", nome: "CEP" },
      { campo: "tipo_logradouro_representante", nome: "Tipo Logradouro" },
      { campo: "logradouro_representante", nome: "Logradouro" },
      { campo: "numero_representante", nome: "Número" },
      { campo: "estado_representante", nome: "Estado" },
      { campo: "cidade_representante", nome: "Cidade" },
      { campo: "bairro_representante", nome: "Bairro" },
      { campo: "complemento_representante", nome: "Complemento" },
    ]);
  }

  validarDependente(): boolean {
    return this.validarCamposObrigatorios("dependente", [
      { campo: "nome", nome: "Nome" },
      { campo: "data_nascimento", nome: "Nascimento" },
      { campo: "cpf", nome: "CPF" },
      { campo: "estado_civil", nome: "Estado Civil" },
      { campo: "sexo", nome: "Sexo" },
      { campo: "estado_naturalidade", nome: "UF de Naturalidade" },
      { campo: "cidade_naturalidade", nome: "Cidade de Naturalidade" },
      { campo: "nacionalidade", nome: "Nacionalidade" },
      { campo: "naturalizado", nome: "Naturalizado" },
      { campo: "escolaridade", nome: "Escolaridade" },
      { campo: "nome_mae", nome: "Nome Mãe" },
      { campo: "deficiente", nome: "Pessoa com deficiência - PCD" },
      { campo: "tipo_logradouro", nome: "Tipo Logradouro" },
      { campo: "logradouro", nome: "Logradouro" },
      { campo: "numero", nome: "Número" },
      { campo: "complemento", nome: "Complemento" },
      { campo: "bairro", nome: "Bairro" },
      { campo: "estado", nome: "Estado" },
      { campo: "cidade", nome: "Cidade" },
      { campo: "cep", nome: "CEP" },
    ]);
  }

  validarAnexo(): boolean {
    return this.validarCamposObrigatorios("anexo", [
      { campo: "referencia", nome: "Referência" },
      { campo: "arquivo", nome: "Documento" },
    ]);
  }

  validarMatricula(): boolean {
    return this.validarCamposObrigatorios("matricula", [
      { campo: "matricula", nome: "Nº da matrícula" },
      { campo: "status", nome: "Status" },
    ]);
  }

  validarMiniEdicao(): boolean {
    return this.validarCamposObrigatorios("mini", [
      { campo: "nome", nome: "Nome" },
      { campo: "cpf", nome: "CPF" },
    ]);
  }

  validarPendencias(): boolean {
    return this.validarCamposObrigatorios("pendencias", [
      { campo: "pendencias", nome: "Pendências" },
    ]);
  }

  async salvarPendencias(): Promise<void> {
    if (!this.validarPendencias()) {
      return;
    }
    await this.editarServidor();
  }

  private valorCampoDadosPessoais(campo: string): any {
    const campos = {
      cep: this.endereco && this.endereco.cep,
      tipo_logradouro: this.endereco && this.endereco.tipo_logradouro,
      estado: this.endereco && this.endereco.estado,
      cidade: this.endereco && this.endereco.cidade,
      logradouro: this.endereco && this.endereco.logradouro,
      numero: this.endereco && this.endereco.numero,
      bairro: this.endereco && this.endereco.bairro,
      complemento: this.endereco && this.endereco.complemento,
      cpf: this.documentos && this.documentos.cpf,
      rg: this.documentos && this.documentos.rg,
      data_emissao_rg: this.documentos && this.documentos.data_emissao_rg,
      orgao_expedidor_rg: this.documentos && this.documentos.orgao_expedidor_rg,
      uf_rg: this.documentos && this.documentos.uf_rg,
      nit: this.documentos && this.documentos.nit,
      telefone: this.contato && this.contato.telefone,
      celular: this.contato && this.contato.celular,
      email: this.contato && this.contato.email,
    };

    return campos[campo];
  }

  private possuiContatoInformado(): boolean {
    return ["telefone", "celular", "email"].some(
      campo => !this.valorVazio(this.valorCampoDadosPessoais(campo))
    );
  }

  validarDadosPessoais(): boolean {
    const obrigatorios = [
      { campo: "cep", nome: "CEP" },
      { campo: "tipo_logradouro", nome: "Tipo de Logradouro" },
      { campo: "estado", nome: "Estado" },
      { campo: "cidade", nome: "Cidade" },
      { campo: "logradouro", nome: "Logradouro" },
      { campo: "numero", nome: "Número" },
      { campo: "bairro", nome: "Bairro" },
      { campo: "complemento", nome: "Complemento" },
      { campo: "cpf", nome: "CPF" },
      { campo: "rg", nome: "RG" },
      { campo: "orgao_expedidor_rg", nome: "Órgão Expedidor" },
      { campo: "uf_rg", nome: "UF do RG" },
      { campo: "nit", nome: "PIS" },
    ];

    if (this.servidor && this.servidor.status && +this.servidor.status !== 1) {
      obrigatorios.push({ campo: "data_emissao_rg", nome: "Emissão do RG" });
    }

    const erros: { [campo: string]: string } = {};
    obrigatorios.forEach(item => {
      if (this.valorVazio(this.valorCampoDadosPessoais(item.campo))) {
        erros[item.campo] = `O campo ${item.nome} é obrigatório.`;
      }
    });

    if (!this.possuiContatoInformado()) {
      const mensagem = "O campo Telefone, Celular ou Email é obrigatório.";
      erros.telefone = mensagem;
      erros.celular = mensagem;
      erros.email = mensagem;
    }

    this.errosDadosPessoais = erros;
    if (Object.keys(erros).length) {
      setTimeout(() => {
        const primeiroInvalido = document.querySelector(
          ".dados-pessoais-form .is-invalid"
        ) as HTMLElement;
        if (primeiroInvalido) {
          primeiroInvalido.focus();
          primeiroInvalido.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 0);
    }

    return Object.keys(erros).length === 0;
  }

  erroCampoDadosPessoais(campo: string): string {
    const mensagem = this.errosDadosPessoais[campo];
    if (!mensagem) {
      return null;
    }

    if (["telefone", "celular", "email"].includes(campo)) {
      return this.possuiContatoInformado() ? null : mensagem;
    }

    return this.valorVazio(this.valorCampoDadosPessoais(campo))
      ? mensagem
      : null;
  }

  private mensagemErroApi(erro: any, mensagemPadrao: string): string {
    const mensagens = [
      erro && erro.error && erro.error.error && erro.error.error.message,
      erro && erro.error && erro.error.message,
      erro && erro.error && typeof erro.error === "string" ? erro.error : null,
      erro && erro.message,
      erro && erro.statusText,
    ];
    const mensagem = mensagens.find(item => typeof item === "string" && item.trim());
    return mensagem || mensagemPadrao;
  }

  private validarRespostaApi<T>(resposta: T, mensagemPadrao: string): T {
    const dados: any = resposta;
    const status = dados && Number(dados.status);
    const possuiErro = dados === false || dados === null || dados === undefined ||
      (dados && dados.success === false) ||
      (dados && dados.ok === false) ||
      (dados && dados.error !== undefined && dados.error !== null && dados.error !== false) ||
      (!isNaN(status) && status >= 400);

    if (possuiErro) {
      throw new Error(this.mensagemErroApi(dados, mensagemPadrao));
    }

    return resposta;
  }

  async atualizarOuCadastrarContato() {
    const self = this;
    if (self.modoSomenteLeitura || self.salvandoDadosPessoais) {
      return;
    }

    if (
      !self.contato ||
      !self.documentos ||
      !self.endereco ||
      !self.idServidor
    ) {
      await self.app.alert(
        "Erro",
        "Não foi possível identificar os dados do servidor. Recarregue a página e tente novamente.",
        "error"
      );
      return;
    }

    if (!self.validarDadosPessoais()) {
      return;
    }

    self.salvandoDadosPessoais = true;
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const rotaContato = self.contato.id
        ? "servidor/contatos/editar"
        : "servidor/contatos/novo";
      const respostaContato = await self.apiCall.get(rotaContato, {
        id: self.contato.id,
        id_servidor: self.idServidor,
        telefone: self.contato.telefone,
        celular: self.contato.celular,
        email: self.contato.email,
      }).pipe(take(1)).toPromise();
      self.validarRespostaApi(
        respostaContato,
        "Não foi possível salvar os dados de contato."
      );

      const documentos = {
        ...self.documentos,
        data_emissao_rg: self.preparaData(self.documentos.data_emissao_rg),
        data_emissao_cpts: self.preparaData(self.documentos.data_emissao_cpts),
      };
      const rotaDocumentos = documentos.id
        ? "servidor/documentos/editar"
        : "servidor/documentos/novo";
      const respostaDocumentos = await self.apiCall.get(rotaDocumentos, {
        id: documentos.id,
        id_servidor: self.idServidor,
        cpf: documentos.cpf,
        nit: documentos.nit,
        rg: documentos.rg,
        data_emissao_rg: documentos.data_emissao_rg,
        orgao_expedidor_rg: documentos.orgao_expedidor_rg,
        uf_rg: documentos.uf_rg,
        cpts: documentos.cpts,
        serie_cpts: documentos.serie_cpts,
        data_emissao_cpts: documentos.data_emissao_cpts,
        titulo_eleitor: documentos.titulo_eleitor,
        zona_titulo_eleitor: documentos.zona_titulo_eleitor,
        secao_titulo_eleitor: documentos.secao_titulo_eleitor,
        uf_titulo_eleitor: documentos.uf_titulo_eleitor,
      }).pipe(take(1)).toPromise();
      self.validarRespostaApi(
        respostaDocumentos,
        "Não foi possível salvar os documentos."
      );

      const rotaEndereco = self.endereco.id
        ? "servidor/endereco/editar"
        : "servidor/endereco/novo";
      const respostaEndereco = await self.apiCall.get(rotaEndereco, {
        id_endereco: self.endereco.id,
        id_servidor: self.idServidor,
        tipo_logradouro: self.endereco.tipo_logradouro,
        logradouro: self.endereco.logradouro,
        numero: self.endereco.numero,
        complemento: self.endereco.complemento,
        bairro: self.endereco.bairro,
        cep: self.endereco.cep,
        estado: self.endereco.estado,
        cidade: self.endereco.cidade,
      }).pipe(take(1)).toPromise();
      self.validarRespostaApi(
        respostaEndereco,
        "Não foi possível salvar o endereço."
      );

      self.errosDadosPessoais = {};
      await self.app.alert(
        "Tudo certo!",
        "Dados pessoais salvos com sucesso!",
        "success"
      );
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível salvar os dados pessoais. Tente novamente."
        ),
        "error"
      );
    } finally {
      self.salvandoDadosPessoais = false;
      await self.spinner.hide();
    }
  }

  async atualizarOuCadastrarObito() {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    if (!self.obito || !self.idServidor) {
      return;
    }
    if (!self.validarObito()) {
      return;
    }
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const obito = prepararCamposData(self.obito, ["data_emissao"]);
      const { id, id_servidor, ...dadosObito } = obito;
      const rota = id ? "servidor/obito/editar" : "servidor/obito/novo";
      const resposta = await self.apiCall
        .get(rota, {
          ...dadosObito,
          id_obito: id,
          id_servidor: self.idServidor,
        })
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(
        resposta,
        "Não foi possível salvar os dados do óbito."
      );
      await this.app.alert(
        "Tudo certo!",
        self.obito.id
          ? "Óbito atualizado com sucesso!"
          : "Óbito cadastrado com sucesso!",
        "success"
      );
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível salvar os dados do óbito. Tente novamente."
        ),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }

  async atualizarOuCadastrarRepresentante() {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    if (!self.representante || !self.idServidor) {
      return;
    }
    if (!self.validarRepresentante()) {
      return;
    }
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const representante = prepararCamposData(self.representante, [
        "data_inicio",
        "data_fim",
        "data_emissao_rg_representante",
        "data_nascimento_representante",
      ]);
      const { id, id_servidor, ...dadosRepresentante } = representante;
      const rota = id
        ? "servidor/representantelegal/editar"
        : "servidor/representantelegal/novo";
      const resposta = await self.apiCall
        .get(rota, {
          ...dadosRepresentante,
          id_representante: id,
          id_servidor: self.idServidor,
        })
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(
        resposta,
        "Não foi possível salvar os dados do representante legal."
      );
      await this.app.alert(
        "Tudo certo!",
        self.representante.id
          ? "Representante Legal atualizado com sucesso!"
          : "Representante Legal cadastrado com sucesso!",
        "success"
      );
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível salvar os dados do representante legal. Tente novamente."
        ),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }

  closeModal(modal) {
    modal.close("Close click");
  }

  getMatriculasServidor(): any[] {
    return MatriculaServidorHelper.getMatriculas(this.servidor, this.idCidade);
  }

  isMatriculaTemporaria(matricula: any = this.matriculaSelecionada): boolean {
    return MatriculaServidorHelper.isTemporaria(matricula);
  }

  getStatusServidor(): number[] {
    return this.getMatriculasServidor()
      .map(matricula => +matricula.status)
      .filter((status, index, statuses) => !!status && statuses.indexOf(status) === index);
  }

  getStatusClass(status: number): string {
    return `status-${status}`;
  }

  selecionarMatricula(matricula: any) {
    if (!matricula || !this.servidor) return;
    this.cancelarEdicaoStatusMatricula();
    this.cancelarEdicaoDadosBeneficioMatricula();
    this.matriculaSelecionada = matricula;
    MatriculaServidorHelper.normalizarServidor(this.servidor, this.idCidade, matricula.id);
    this.oldStatus = this.servidor.status;

    const urlMatricula = this.router.createUrlTree([], {
      relativeTo: this.route,
      queryParams: { id_matricula: matricula.id },
      queryParamsHandling: 'merge',
    });
    this.location.replaceState(this.router.serializeUrl(urlMatricula));

    // A troca de status pode alterar a altura dos dados acima deste card.
    // Reposiciona após o Angular atualizar a tela para manter o usuário aqui.
    setTimeout(() => this.rolarParaMatriculas(), 0);
  }

  iniciarEdicaoStatusMatricula() {
    if (
      this.modoSomenteLeitura ||
      !this.matriculaSelecionada ||
      this.isMatriculaTemporaria()
    ) return;
    this.statusMatriculaEmEdicao = +this.matriculaSelecionada.status;
    this.editandoStatusMatricula = true;
  }

  cancelarEdicaoStatusMatricula() {
    this.editandoStatusMatricula = false;
    this.statusMatriculaEmEdicao = null;
  }

  async salvarStatusMatricula() {
    if (
      this.modoSomenteLeitura ||
      !this.matriculaSelecionada ||
      this.isMatriculaTemporaria() ||
      !this.matriculaSelecionada.id ||
      this.salvandoStatusMatricula
    ) {
      return;
    }

    const status = Number(this.statusMatriculaEmEdicao);
    if (!Number.isInteger(status) || status < 1 || status > 5) {
      await this.app.alert(
        'Atenção!',
        'Selecione um status válido para a matrícula.',
        'warning'
      );
      return;
    }

    if (status === +this.matriculaSelecionada.status) {
      this.cancelarEdicaoStatusMatricula();
      return;
    }

    this.salvandoStatusMatricula = true;
    try {
      const resposta: any = await this.apiCall.post('servidor/matricula/editar', {
        id_matricula: this.matriculaSelecionada.id,
        status,
      }).pipe(take(1)).toPromise();
      this.validarRespostaApi(
        resposta,
        'Não foi possível atualizar o status da matrícula.'
      );

      this.cancelarEdicaoStatusMatricula();
      await this.app.alert(
        'Tudo certo!',
        'Status da matrícula atualizado com sucesso!',
        'success'
      );
      await this.ngOnInit();
    } catch (erro) {
      await this.app.alert(
        'Erro',
        this.mensagemErroApi(
          erro,
          'Não foi possível atualizar o status da matrícula. Tente novamente.'
        ),
        'error'
      );
    } finally {
      this.salvandoStatusMatricula = false;
    }
  }

  podeEditarDadosBeneficioMatricula(): boolean {
    if (
      this.modoSomenteLeitura ||
      !this.matriculaSelecionada ||
      this.isMatriculaTemporaria()
    ) return false;
    return [2, 3].includes(Number(this.matriculaSelecionada.status));
  }

  iniciarEdicaoDadosBeneficioMatricula() {
    if (!this.podeEditarDadosBeneficioMatricula()) return;

    const matricula = this.matriculaSelecionada;
    const valor = (campo: string) => matricula[campo] !== undefined
      ? matricula[campo]
      : this.servidor[campo];
    const data = (campo: string) => {
      const formatada = this.formatarDataMatricula(valor(campo));
      return formatada === '---' ? null : formatada;
    };

    this.dadosBeneficioMatricula = {
      matricula: matricula.matricula,
      orgao: matricula.orgao !== undefined ? matricula.orgao : this.servidor.orgao,
      concessao_aposentadoria: data('concessao_aposentadoria'),
      paridade_aposentadoria: valor('paridade_aposentadoria'),
      tipo_fundo: valor('tipo_fundo'),
      valor_aposentadoria: this.formatarMoedaParaEdicao(valor('valor_aposentadoria')),
      cargo_aposentadoria: valor('cargo_aposentadoria'),
      pis_aposentado: valor('pis_aposentado'),
      tipo_aposentadoria: valor('tipo_aposentadoria'),
      valor_beneficio: this.formatarMoedaParaEdicao(valor('valor_beneficio')),
      tipo_pensao: valor('tipo_pensao'),
      cpf_pensao: valor('cpf_pensao'),
      pis_pensao: valor('pis_pensao'),
      nome_pensao: valor('nome_pensao'),
      matricula_pensao: valor('matricula_pensao'),
      data_nascimento_pensao: data('data_nascimento_pensao'),
      data_falecimento_pensao: data('data_falecimento_pensao'),
      relacao_titular_pensao: valor('relacao_titular_pensao'),
    };
    this.limparValidacaoFormulario('beneficio-matricula');
    this.editandoDadosBeneficioMatricula = true;
  }

  cancelarEdicaoDadosBeneficioMatricula() {
    this.editandoDadosBeneficioMatricula = false;
    this.dadosBeneficioMatricula = null;
    this.limparValidacaoFormulario('beneficio-matricula');
  }

  validarDadosBeneficioMatricula(): boolean {
    const campos = [
      { campo: 'matricula', nome: 'Matrícula' },
      { campo: 'tipo_fundo', nome: 'Tipo de Fundo' },
    ];

    if (+this.matriculaSelecionada.status === 2) {
      campos.push({ campo: 'orgao', nome: 'Órgão' });
    } else if (+this.matriculaSelecionada.status === 3) {
      campos.push(
        { campo: 'nome_pensao', nome: 'Nome do Instituidor' },
        { campo: 'cpf_pensao', nome: 'CPF do Instituidor' }
      );
    }

    return this.validarCamposObrigatorios('beneficio-matricula', campos);
  }

  async salvarDadosBeneficioMatricula() {
    if (
      !this.podeEditarDadosBeneficioMatricula() ||
      !this.dadosBeneficioMatricula ||
      this.salvandoDadosBeneficioMatricula
    ) {
      return;
    }

    if (!this.validarDadosBeneficioMatricula()) return;

    const dados = this.dadosBeneficioMatricula;
    const concessao = this.prepararDataBeneficioMatricula(
      dados.concessao_aposentadoria,
      'Data de Concessão do Benefício'
    );
    if (concessao === undefined) return;

    const numeroMatricula = String(dados.matricula || '').trim();
    if (!numeroMatricula) {
      await this.app.alert('Atenção!', 'Informe o número da matrícula.', 'warning');
      return;
    }

    const payload: any = {
      id_matricula: this.matriculaSelecionada.id,
      matricula: numeroMatricula,
      orgao: this.valorOpcional(dados.orgao),
      concessao_aposentadoria: concessao,
      paridade_aposentadoria: this.valorOpcional(dados.paridade_aposentadoria),
      tipo_fundo: this.valorOpcional(dados.tipo_fundo),
    };

    if (+this.matriculaSelecionada.status === 2) {
      payload.valor_aposentadoria = this.normalizarValorMonetario(dados.valor_aposentadoria);
      payload.cargo_aposentadoria = this.valorOpcional(dados.cargo_aposentadoria);
      payload.pis_aposentado = this.valorOpcional(dados.pis_aposentado);
      payload.tipo_aposentadoria = this.valorOpcional(dados.tipo_aposentadoria);
    } else {
      const nascimento = this.prepararDataBeneficioMatricula(
        dados.data_nascimento_pensao,
        'Data de Nascimento do Instituidor'
      );
      if (nascimento === undefined) return;
      const falecimento = this.prepararDataBeneficioMatricula(
        dados.data_falecimento_pensao,
        'Data de Falecimento do Instituidor'
      );
      if (falecimento === undefined) return;

      payload.valor_beneficio = this.normalizarValorMonetario(dados.valor_beneficio);
      payload.tipo_pensao = this.valorOpcional(dados.tipo_pensao);
      payload.cpf_pensao = this.valorOpcional(dados.cpf_pensao);
      payload.pis_pensao = this.valorOpcional(dados.pis_pensao);
      payload.nome_pensao = this.valorOpcional(dados.nome_pensao);
      payload.matricula_pensao = this.valorOpcional(dados.matricula_pensao);
      payload.data_nascimento_pensao = nascimento;
      payload.data_falecimento_pensao = falecimento;
      payload.relacao_titular_pensao = this.valorOpcional(dados.relacao_titular_pensao);
    }

    this.salvandoDadosBeneficioMatricula = true;
    try {
      const resposta: any = await this.apiCall
        .post('servidor/matricula/editar', payload)
        .pipe(take(1))
        .toPromise();
      this.validarRespostaApi(
        resposta,
        'Não foi possível atualizar os dados do benefício desta matrícula.'
      );

      this.cancelarEdicaoDadosBeneficioMatricula();
      await this.app.alert(
        'Tudo certo!',
        'Dados do benefício atualizados somente nesta matrícula.',
        'success'
      );
      await this.ngOnInit();
    } catch (erro) {
      await this.app.alert(
        'Erro',
        this.mensagemErroApi(
          erro,
          'Não foi possível atualizar os dados do benefício. Tente novamente.'
        ),
        'error'
      );
    } finally {
      this.salvandoDadosBeneficioMatricula = false;
    }
  }

  private prepararDataBeneficioMatricula(valor: any, label: string): string | null | undefined {
    if (valor === null || valor === undefined || String(valor).trim() === '') return null;
    const data = this.preparaData(valor);
    if (!data) {
      this.app.alert('Atenção!', `${label} inválida.`, 'warning');
      return undefined;
    }
    return data;
  }

  private valorOpcional(valor: any): any {
    return valor === null || valor === undefined || String(valor).trim() === '' ? null : valor;
  }

  private formatarMoedaParaEdicao(valor: any): any {
    if (valor === null || valor === undefined || valor === '') return null;
    return String(valor).replace('.', ',');
  }

  private normalizarValorMonetario(valor: any): number | null {
    if (valor === null || valor === undefined || String(valor).trim() === '') return null;
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;

    const texto = String(valor).replace(/R\$|\s/g, '');
    const possuiDecimalBrasileiro = texto.indexOf(',') >= 0;
    const possuiApenasMilharesBrasileiros = /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const normalizado = possuiDecimalBrasileiro
      ? texto.replace(/\./g, '').replace(',', '.')
      : possuiApenasMilharesBrasileiros
        ? texto.replace(/\./g, '')
        : texto;
    const numero = Number(normalizado);
    return Number.isFinite(numero) ? numero : null;
  }

  isMatriculaSelecionada(matricula: any): boolean {
    return !!matricula && !!this.matriculaSelecionada && matricula.id == this.matriculaSelecionada.id;
  }

  getMovimentosMatricula(): any[] {
    if (!this.matriculaSelecionada) return [];
    return this.movimentosFuncionais.filter(movimento =>
      movimento.id_matricula != null && movimento.id_matricula == this.matriculaSelecionada.id
    );
  }

  temMatriculaAtiva(): boolean {
    return this.getMatriculasServidor().some(matricula =>
      !this.isMatriculaTemporaria(matricula) && +matricula.status === 1
    );
  }

  isMatriculaSelecionadaAtiva(): boolean {
    return !!this.matriculaSelecionada &&
      !this.isMatriculaTemporaria() &&
      +this.matriculaSelecionada.status === 1;
  }

  getEstadoMatricula(matricula: any): string {
    if (!matricula) return '---';
    const status = +matricula.status;
    return matricula.ativo == 0 || status === 4 || status === 5 ? 'Inativa' : 'Ativa';
  }

  getMunicipioMatricula(matricula: any): string {
    if (!matricula) return '---';
    return matricula.nome_cidade ||
      (this.servidor && (this.servidor.nome_cidade || this.servidor.nomecidade)) ||
      this.getNomeCidadeMatricula() ||
      '---';
  }

  getSecoesDetalhesMatricula(): any[] {
    if (
      !this.matriculaSelecionada ||
      this.isMatriculaTemporaria() ||
      !this.servidor
    ) return [];

    const status = +this.matriculaSelecionada.status;
    const movimento = this.getMovimentoAtualMatricula();
    const matricula = this.matriculaSelecionada.matricula || '---';

    if (status === 1) {
      return [{
        titulo: 'Dados do Vínculo',
        campos: [
          this.campoMatricula('Tipo de Vínculo', movimento.tipo_vinculo || this.servidor.tipo_vinculo),
          this.campoMatricula('Data de Nomeação', this.formatarDataMatricula(movimento.data_nomeacao)),
          this.campoMatricula('Decreto', movimento.decreto_nomeacao),
          this.campoMatricula('Regime Previdenciário', movimento.regime_previdenciario),
          this.campoMatricula('Órgão', this.getOrgaoMatricula(this.matriculaSelecionada)),
          this.campoMatricula('Cargo Atual', movimento.cargo),
          this.campoMatricula('Carga Horária', movimento.carga_horaria),
          this.campoMatricula('Situação Funcional', this.getSituacaoFuncional(movimento.situacao_funcional)),
        ]
      }];
    }

    if (status === 2) {
      return [{
        titulo: 'Aposentadoria',
        campos: [
          this.campoMatricula('Matrícula', matricula),
          this.campoMatricula('Órgão', this.getOrgaoMatricula(this.matriculaSelecionada)),
          this.campoMatricula('Ingresso no Serviço Público', this.formatarDataMatricula(this.servidor.data_ingresso_servico_publico)),
          this.campoMatricula('Concessão do Benefício', this.formatarDataMatricula(this.servidor.concessao_aposentadoria)),
          this.campoMatricula('Tipo de Aposentadoria', this.getDescricaoLista(this.tiposaposentadoria, this.servidor.tipo_aposentadoria)),
          this.campoMatricula('Tipo de Fundo', this.servidor.tipo_fundo),
          this.campoMatricula('Cargo Aposentado', this.servidor.cargo_aposentadoria || movimento.cargo),
          this.campoMatricula('Valor Atual', this.formatarMoedaMatricula(this.servidor.valor_aposentadoria)),
          this.campoMatricula('PIS do Aposentado', this.servidor.pis_aposentado),
          this.campoMatricula('Paridade', this.getDescricaoLista(this.naturalizados, this.servidor.paridade_aposentadoria)),
        ]
      }];
    }

    if (status === 3) {
      return [
        {
          titulo: 'Pensão',
          campos: [
            this.campoMatricula('Matrícula do Beneficiário', matricula),
            this.campoMatricula('Órgão', this.getOrgaoMatricula(this.matriculaSelecionada)),
            this.campoMatricula('Tipo de Fundo', this.servidor.tipo_fundo),
            this.campoMatricula('Concessão do Benefício', this.formatarDataMatricula(this.servidor.concessao_aposentadoria)),
            this.campoMatricula('Valor do Benefício', this.formatarMoedaMatricula(this.servidor.valor_beneficio)),
            this.campoMatricula('Tipo de Pensão', this.getDescricaoLista(this.tipospensao, this.servidor.tipo_pensao)),
            this.campoMatricula('Paridade', this.getDescricaoLista(this.naturalizados, this.servidor.paridade_aposentadoria)),
          ]
        },
        {
          titulo: 'Instituidor da Pensão',
          campos: [
            this.campoMatricula('Nome do Instituidor', this.servidor.nome_pensao),
            this.campoMatricula('Relação com o Titular', this.getDescricaoLista(this.relacaoTitularPensao, this.servidor.relacao_titular_pensao)),
            this.campoMatricula('Nascimento', this.formatarDataMatricula(this.servidor.data_nascimento_pensao)),
            this.campoMatricula('Falecimento', this.formatarDataMatricula(this.servidor.data_falecimento_pensao)),
            this.campoMatricula('Matrícula do Instituidor', this.servidor.matricula_pensao),
            this.campoMatricula('PIS', this.servidor.pis_pensao),
            this.campoMatricula('CPF', this.servidor.cpf_pensao),
          ]
        }
      ];
    }

    if (status === 4) {
      return [{
        titulo: 'Exoneração',
        campos: [
          this.campoMatricula('Matrícula', matricula),
          this.campoMatricula('Motivo da Exoneração', this.servidor.motivo_exoneracao || movimento.tipo_exoneracao),
          this.campoMatricula('Data da Exoneração', this.formatarDataMatricula(movimento.data_saida)),
          this.campoMatricula('Cargo Exonerado', movimento.cargo),
          this.campoMatricula('Data de Nomeação', this.formatarDataMatricula(movimento.data_nomeacao)),
        ]
      }];
    }

    return [{
      titulo: 'Falecimento',
      campos: [
        this.campoMatricula('Matrícula', matricula),
        this.campoMatricula('Data de Falecimento', this.formatarDataMatricula(this.servidor.data_falecimento)),
        this.campoMatricula('Documento de Ingresso', this.servidor.documento_ingresso_servico_publico),
        this.campoMatricula('Cargo na Data do Óbito', movimento.cargo || this.servidor.cargo_aposentadoria),
        this.campoMatricula('Situação Anterior', movimento.situacao_anterior),
      ]
    }];
  }

  private getMovimentoAtualMatricula(): any {
    const movimentos = this.getMovimentosMatricula();
    if (!movimentos.length) return {};
    return movimentos.slice().sort((a, b) => (+b.id || 0) - (+a.id || 0))[0];
  }

  private campoMatricula(label: string, valor: any): any {
    return { label, valor: valor !== null && valor !== undefined && valor !== '' ? valor : '---' };
  }

  formatarDataMatricula(valor: any): string {
    if (valor === null || valor === undefined) return '---';

    const texto = String(valor).trim();
    if (!texto) return '---';

    const data = moment.parseZone(
      texto,
      ['DD/MM/YYYY', 'DDMMYYYY', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601],
      true
    );

    return data.isValid() ? data.format('DD/MM/YYYY') : texto;
  }

  private formatarMoedaMatricula(valor: any): string {
    if (valor === null || valor === undefined || valor === '') return '---';
    const texto = String(valor);
    return /^R\$/i.test(texto) ? texto : `R$ ${texto}`;
  }

  private getDescricaoLista(lista: any[], valor: any): string {
    if (valor === null || valor === undefined || valor === '') return '---';
    const item = (lista || []).find(opcao =>
      opcao && (opcao.id == valor || opcao.value == valor || opcao.name == valor)
    );
    return item ? item.name : String(valor);
  }

  private getSituacaoFuncional(valor: any): string {
    const situacoes = [
      { id: 1, name: 'Em Exercício' },
      { id: 2, name: 'Em Auxílio' },
      { id: 6, name: 'Outros' },
    ];
    return this.getDescricaoLista(situacoes, valor);
  }

  isPensionistaPuro(): boolean {
    const matriculas = this.getMatriculasServidor();
    return matriculas.length > 0 && matriculas.every(matricula => +matricula.status === 3);
  }

  toggleMatriculaData() {
    this.isMatriculaDataVisible = !this.isMatriculaDataVisible;
  }

  toggleTempoServico() {
    this.isTempoServicoVisible = !this.isTempoServicoVisible;
  }

  private inicializarConferencia() {
    if (!this.servidor || this.conferenciaServidorId == this.servidor.id) return;
    this.conferenciaServidorId = this.servidor.id;
    const conferido = this.servidor.situacao_nova === 'conferido';
    Object.keys(this.conferenciaBlocos).forEach(chave => {
      this.conferenciaBlocos[chave] = conferido;
    });
    if (sessionStorage.getItem(`census-tsp-conferido-${this.servidor.id}`) === '1') {
      this.conferenciaBlocos.tsp = true;
    }
    this.conferenciaMatriculas = {};
    this.getMatriculasServidor().forEach(matricula => {
      const estatistica = this.estatisticasConferencia.find(item => item.id_matricula == matricula.id);
      this.conferenciaMatriculas[String(matricula.id)] = estatistica
        ? estatistica.situacao === 'conferido'
        : conferido;
    });
  }

  getPassosConferencia(): any[] {
    const passos = [
      { chave: 'principal', label: 'Informações básicas', conferido: this.conferenciaBlocos.principal },
      { chave: 'dependentes', label: 'Dependentes', conferido: this.conferenciaBlocos.dependentes, oculto: this.isPensionistaPuro() },
      { chave: 'anexos', label: 'Documentos Anexos', conferido: this.conferenciaBlocos.anexos },
      { chave: 'gerais', label: 'Dados Funcionais Gerais', conferido: this.conferenciaBlocos.gerais },
      {
        chave: 'matriculas',
        label: 'Matrículas & Movimentos',
        conferido: this.getMatriculasServidor()
          .filter(matricula => !this.isMatriculaTemporaria(matricula))
          .every(matricula => this.conferenciaMatriculas[String(matricula.id)])
      },
      { chave: 'tsp', label: 'Tempo de serviço (CPF)', conferido: this.conferenciaBlocos.tsp, oculto: !this.temMatriculaAtiva() },
    ].filter(passo => !passo.oculto);
    const proximo = passos.find(passo => !passo.conferido);
    return passos.map(passo => ({ ...passo, proximo: passo === proximo }));
  }

  conferenciaCompleta(): boolean {
    return this.getPassosConferencia().every(passo => passo.conferido);
  }

  getSituacaoConferenciaLabel(): string {
    if (this.servidor && this.servidor.situacao_nova === 'conferido') return 'CONFERIDO';
    return 'EM CONFERÊNCIA';
  }

  getMatriculaConferida(): boolean {
    if (!this.matriculaSelecionada || this.isMatriculaTemporaria()) return false;
    return this.conferenciaBlocos.gerais &&
      !!this.conferenciaMatriculas[String(this.matriculaSelecionada.id)];
  }

  setMatriculaConferida(conferida: boolean) {
    if (this.modoSomenteLeitura || this.isMatriculaTemporaria()) {
      return;
    }

    if (!this.matriculaSelecionada) return;
    this.conferenciaBlocos.gerais = conferida;
    this.conferenciaMatriculas[String(this.matriculaSelecionada.id)] = conferida;
  }

  getTotalTempoServico(): number {
    return this.temposServico.reduce((total, tempo) => total + (+tempo.tempo_bruto || 0), 0);
  }

  getOrgaoMatricula(matricula: any): string {
    if (!matricula) return '---';
    const orgao = this.orgaos.find(item => item.id == matricula.orgao);
    return orgao ? orgao.descricao : (matricula.administracao || '---');
  }

  getNomeCidadeMatricula(): string {
    const matricula = this.getMatriculasServidor()[0];
    const usuario: any = this.me.currentUserValue;
    return (matricula && matricula.nome_cidade) ||
      (this.servidor && this.servidor.nome_cidade) ||
      (usuario && usuario.user && usuario.user.nomeCidade) ||
      'Município atual';
  }

  async adicionarMatricula(modal: any) {
    if (this.modoSomenteLeitura) {
      return;
    }

    if (!this.validarMatricula()) {
      return;
    }
    if (!/^\d+$/.test(String(this.novaMatricula.matricula))) {
      await this.app.alert('Atenção!', 'Use somente números no campo de matrícula.', 'warning');
      return;
    }
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
      const resposta: any = await this.apiCall.post('servidor/matricula/novo', {
        id_servidor: this.idServidor,
        id_cidade: this.idCidade,
        matricula: this.novaMatricula.matricula,
        status: this.novaMatricula.status,
        orgao: this.servidor && this.servidor.orgao,
        cargo_atual: this.novaMatricula.cargo_atual || null,
        data_nomeacao: this.novaMatricula.data_nomeacao || null,
      }).pipe(take(1)).toPromise();
      this.validarRespostaApi(resposta, 'Não foi possível adicionar a matrícula.');
      const idMatricula = resposta.id || resposta.id_matricula;
      modal.close('Matrícula adicionada');
      this.novaMatricula = {
        matricula: '',
        status: 1,
        cargo_atual: '',
        data_nomeacao: null,
      };
      await this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          id_matricula: idMatricula,
          secao: 'matriculas',
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
      await this.ngOnInit();
    } catch (error) {
      await this.app.alert(
        'Erro!',
        error && error.message ? error.message : 'Não foi possível adicionar a matrícula.',
        'error'
      );
    } finally {
      this.spinner.hide();
    }
  }

  getStatus(status) {
    return this.statusServidor.find((item) => item.id === +status)?.name || 'Sem status';
  }

  comeBack() {
    window.history.back();
  }
  async atualizarOuCadastrarDependente(modal) {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }

    if (!self.dependente || !self.idServidor) {
      return;
    }
    if (!self.validarDependente()) {
      return;
    }
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    try {
    const dadosDependente = prepararCamposData(this.dependente, [
      "data_nascimento",
      "data_emissao_rg",
      "inicio_dependencia",
      "fim_dependencia",
    ]);
    this.dependente.bairro = (this.dependente.bairro ?? "").replace(/['`]/g, " ");
    this.dependente.logradouro = (this.dependente.logradouro ?? "").replace(/['`]/g, " ");
    this.dependente.complemento = (this.dependente.complemento ?? "").replace(/['`]/g, " ");
    this.dependente.nome = (this.dependente.nome ?? "").replace(/['`]/g, " ");
    this.dependente.nome_mae = (this.dependente.nome_mae ?? "").replace(/['`]/g, " ");
    this.dependente.nome_pai = (this.dependente.nome_pai ?? "").replace(/['`]/g, " ");
    let resposta;
    if (self.dependente.id) {
      resposta = await self.apiCall
        .get(
          `servidor/dependente/editar?id_dependente=${
            self.dependente.id
          }&nome=${this.validateQuotes(this.dependente.nome)}&estado_civil=${
            this.dependente.estado_civil
          }&data_nascimento=${dadosDependente.data_nascimento}&nacionalidade=${
            this.dependente.nacionalidade
          }&estado_naturalidade=${
            this.dependente.estado_naturalidade
          }&cidade_naturalidade=${
            this.dependente.cidade_naturalidade
          }&naturalizado=${this.dependente.naturalizado}&escolaridade=${
            this.dependente.escolaridade
          }&sexo=${this.dependente.sexo}&nome_mae=${this.validateQuotes(
            this.dependente.nome_mae
          )}&nome_pai=${this.validateQuotes(
            this.dependente.nome_pai
          )}&deficiente=${this.dependente.deficiente}&cpf=${
            this.dependente.cpf
          }&rg=${this.dependente.rg}&data_emissao_rg=${
            dadosDependente.data_emissao_rg
          }&orgao_expedidor_rg=${this.dependente.orgao_expedidor_rg}&uf_rg=${
            this.dependente.uf_rg
          }&pis_pasep=${this.dependente.pis_pasep}&numero_certidao=${
            this.dependente.numero_certidao
          }&livro=${this.dependente.livro}&folha=${
            this.dependente.folha
          }&tipo_logradouro=${this.dependente.tipo_logradouro}&logradouro=${
            this.dependente.logradouro
          }&numero=${this.dependente.numero}&complemento=${
            this.dependente.complemento
          }&bairro=${this.dependente.bairro}&cep=${
            this.dependente.cep
          }&estado=${this.dependente.estado}&cidade=${
            this.dependente.cidade
          }&telefone=${this.dependente.telefone}&celular=${
            this.dependente.celular
          }&email=${this.dependente.email}&tipo_dependencia=${
            this.dependente.tipo_dependencia
          }&motivo_inicio=${this.dependente.motivo_inicio}&motivo_fim=${
            this.dependente.motivo_fim
          }&inicio_dependencia=${
            dadosDependente.inicio_dependencia
          }&fim_dependencia=${
            dadosDependente.fim_dependencia
          }&fins_previdenciarios=${this.dependente.fins_previdenciarios}`
        )
        .pipe(take(1))
        .toPromise();
    } else {
      resposta = await self.apiCall
        .get(
          `servidor/dependente/novo?id_servidor=${
            this.idServidor
          }&nome=${this.validateQuotes(this.dependente.nome)}&estado_civil=${
            this.dependente.estado_civil
          }&data_nascimento=${dadosDependente.data_nascimento}&nacionalidade=${
            this.dependente.nacionalidade
          }&estado_naturalidade=${
            this.dependente.estado_naturalidade
          }&cidade_naturalidade=${
            this.dependente.cidade_naturalidade
          }&naturalizado=${this.dependente.naturalizado}&escolaridade=${
            this.dependente.escolaridade
          }&sexo=${this.dependente.sexo}&nome_mae=${this.validateQuotes(
            this.dependente.nome_mae
          )}&nome_pai=${this.validateQuotes(
            this.dependente.nome_pai
          )}&deficiente=${this.dependente.deficiente}&cpf=${
            this.dependente.cpf
          }&rg=${this.dependente.rg}&data_emissao_rg=${
            dadosDependente.data_emissao_rg
          }&orgao_expedidor_rg=${this.dependente.orgao_expedidor_rg}&uf_rg=${
            this.dependente.uf_rg
          }&pis_pasep=${this.dependente.pis_pasep}&numero_certidao=${
            this.dependente.numero_certidao
          }&livro=${this.dependente.livro}&folha=${
            this.dependente.folha
          }&tipo_logradouro=${this.dependente.tipo_logradouro}&logradouro=${
            this.dependente.logradouro
          }&numero=${this.dependente.numero}&complemento=${
            this.dependente.complemento
          }&bairro=${this.dependente.bairro}&cep=${
            this.dependente.cep
          }&estado=${this.dependente.estado}&cidade=${
            this.dependente.cidade
          }&telefone=${this.dependente.telefone}&celular=${
            this.dependente.celular
          }&email=${this.dependente.email}&tipo_dependencia=${
            this.dependente.tipo_dependencia
          }&motivo_inicio=${this.dependente.motivo_inicio}&motivo_fim=${
            this.dependente.motivo_fim
          }&inicio_dependencia=${
            dadosDependente.inicio_dependencia
          }&fim_dependencia=${
            dadosDependente.fim_dependencia
          }&fins_previdenciarios=${this.dependente.fins_previdenciarios}`
        )
        .pipe(take(1))
        .toPromise();
    }
    self.validarRespostaApi(
      resposta,
      "Não foi possível salvar os dados do dependente."
    );
    await this.app.alert(
      "Tudo certo!",
      self.dependente.id
        ? "Dependente atualizado com sucesso!"
        : "Dependente cadastrado com sucesso!",
      "success"
    );
    modal.close("Close click");
    await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível salvar os dados do dependente. Tente novamente."
        ),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }

  onTabChange(event){
    console.log("clicou")
    if(this.isEditingBasicInfos || this.isEditingObservations || this.isEditingPersonalData || this.isEditingObito || this.isEditingRepresentante){
      event.preventDefault();
      this.app.alert('Atenção', 'Você está editando um campo, por favor termine a edição ou cancele antes de mudar de aba', 'info');
    }
  }

  checkMunicipio(){
    const retorno = this.municipiosSemValidacao.find(x => x == this.idCidade)
    console.log(retorno ? true : false)
    return retorno ? true : false
  }

  openMiniEdit(modal){
    if (this.modoSomenteLeitura) {
      return;
    }

    this.limparValidacaoFormulario("mini");
    this.modalService.open(modal, {
      centered: true,size: "lg",})
  }
  

  async miniEditServidor(modal) {
    if (this.modoSomenteLeitura) {
      return;
    }
    if (!this.servidor || !this.servidor.id || !this.validarMiniEdicao()) {
      return;
    }

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    const self = this
    const body = {
      idServidor: this.servidor.id,
      nomeServidor: this.servidor.nome,
      cpfServidor: this.documentos.cpf
    };
  
    try {
      const resposta = await self.apiCall
        .post('servidor/mini-edit', body)
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(
        resposta,
        "Não foi possível atualizar os dados do servidor."
      );
      await self.app.alert(
        "Tudo certo!",
        "Dados atualizados com sucesso",
        "success"
      );
      modal.close("Close click");
      await self.ngOnInit();
    } catch (erro) {
      await self.app.alert(
        "Ocorreu um erro",
        self.mensagemErroApi(
          erro,
          "Não foi possível atualizar os dados do servidor. Tente novamente."
        ),
        "error"
      );
    } finally {
      await self.spinner.hide();
    }
  }
  
  // Método para finalizar conferência
  async finalizarConferencia() {
    const self = this;
    if (self.modoSomenteLeitura) {
      return;
    }
    self.situacaoConferencia = 'conferido';
    
    if (!self.idServidor || !self.idCidade || !self.idConferidor ||
        !self.matriculaSelecionada || !self.matriculaSelecionada.id ||
        self.isMatriculaTemporaria()) {
      await self.app.alert('Erro!', 'Dados insuficientes para finalizar a conferência.', 'error');
      return;
    }
    
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    try {
      // Preparar dados para registrar ação de conferência
      const dadosEstatistica: any = {
        id_servidor: self.idServidor,
        id_matricula: self.matriculaSelecionada.id,
        id_cidade: self.idCidade,
        id_conferidor: self.idConferidor,
        situacao: self.situacaoConferencia,
        observacoes: `Conferência finalizada como ${self.situacaoConferencia}`
      };
      
      // Chamar endpoint para registrar ação de conferência
      const response = await self.apiCall
        .post('conferidores/estatisticas/acao', dadosEstatistica)
        .pipe(take(1))
        .toPromise();
      self.validarRespostaApi(response, 'Erro ao finalizar conferência');
      
      const responseData = response ? JSON.parse(JSON.stringify(response)) : null;
      
      if (responseData && responseData.success) {
        self.spinner.hide();
        await self.app.alert('Sucesso!', 'Conferência finalizada com sucesso!', 'success');
        Object.keys(self.conferenciaBlocos).forEach(chave => {
          self.conferenciaBlocos[chave] = true;
        });
        self.getMatriculasServidor().forEach(matricula => {
          self.conferenciaMatriculas[String(matricula.id)] = true;
        });
        self.servidor.situacao_nova = 'conferido';
      } else {
        throw new Error(responseData?.message || 'Erro ao finalizar conferência');
      }
    } catch (error) {
      console.error('Erro ao finalizar conferência:', error);
      self.spinner.hide();
      await self.app.alert('Erro!', error.message || 'Erro ao finalizar conferência. Tente novamente.', 'error');
    }
  }
}

/* documentos finalizado
1. Rota para buscar documentos - ok
2. Card para exibir documentos - ok
3. Funções de baixar e excluir doc - ok
4. Botão para add doc - ok
4. Modal para upload de doc - ok 

====================

dependentes

1. Rota para buscar dependentes
2. Card para exibir dependentes
3. Funções de adicionar, editar e excluir dependentes 

Forms do card inicial




*/
